import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ImagingToolEvent} from './models/imaging-tool.event';
import {ImagingTopMenuEvent} from './imaging-top-menu/models/imaging-top-menu.event';
import {TDOxImage} from './models/imaging-image.model';
import {Globals} from '../../globals';
import {FileManagerService} from '../../modules/file-manager/file-manager.service';
import {MessagingService} from '../../services/messaging.service';
import {Subscription} from 'rxjs';
import {TdoImagingImageContainerComponent} from './tdo-imaging-image-container/tdo-imaging-image-container.component';
import {SelectSourceDlgComponent} from '../../modules/imaging/select-source-dlg/select-source-dlg.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {v4 as uuidv4} from 'uuid';
import {DocumentDataModel} from '../../models/document/document-data.model';
import {confirm} from 'devextreme/ui/dialog';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../services/static-data.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FolderMonitorName, TdoImagingService} from './tdo-imaging.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {SignalrService} from '../../services/socket/signalr.service';
import {DesktopAcquireCommandsModel} from './models/desktop-acquire-commands.model';
import {CaseTooth} from './models/CaseTooth';
import {DialogService} from '../../services/dialog.service';
import {Constants} from '../../constants';
import {TdoMdiManagerComponent} from '../../tdo-controls/tdo-mdi-manager/tdo-mdi-manager.component';
import {AnnotationObjectIdEnum} from './models/AnnotationObjectIdEnum';
import {TdoMdiItemComponent} from '../../tdo-controls/tdo-mdi-manager/tdo-mdi-item/tdo-mdi-item.component';
import {TdoMdiBoundsModel} from '../../tdo-controls/tdo-mdi-manager/models/tdo-mdi-bounds.model';
import {OrganizerOpenInImagingModel} from '../controls/tdo-organizer/models/organizer-open-in-imaging.model';
import {DocumentGroupCreationModel} from '../../models/document/document-group-creation.model';
// import {cfgDrawParameter} from '../../models/configuration/draw/annotation-defaults.model';
import {
  AnnotationDefaults,
  cfgDrawParameter, DrawCanvasDefaults, DrawFunctionDefaults,
  DrawingToolsDefaults, DrawMagnificationDefaults,
  DrawStampDefaults,
  DrawTextDefaults
} from '../../models/configuration/draw/annotation-defaults.model';
import {DrawDefaultsService} from '../../modules/configuration/draw-defaults/draw-defaults.service';
import {rejects} from 'assert';
import {DevicesService} from '../../modules/configuration/devices/devices.service';
import {DeviceConfigurationModel} from '../../models/configuration/device-configuration.model';
import {WorkstationDevicesConfigurationModel} from '../../models/configuration/workstation-devices-configuration.model';
import {TdoDropdownModel} from '../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {DropDownListItems} from './imaging-top-menu/imaging-top-menu.component';
import {DocumentTagDataModel} from '../../models/document/document-tag-data.model';
import {MessagingConstants} from '../../models/MessagingConstants';
import {SocketMessageModel} from '../../services/socket/models/socket-message.model';
import {AuthenticationService} from '../../modules/auth/services/authentication.service';
import {TdoOrganizerComponent} from '../controls/tdo-organizer/tdo-organizer.component';
import {DocumentsPerFolderModel} from '../../models/document/documents-per-folder.model';
import {coerceStringArray} from '@angular/cdk/coercion';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';
import { DEVICE_CATEGORY } from 'src/app/models/constants/device-category.model';

@Component({
  standalone: false,
  selector: 'app-tdo-imaging',
  templateUrl: './tdo-imaging.component.html',
  styleUrls: ['./tdo-imaging.component.scss']
})
export class TdoImagingComponent implements OnInit, AfterViewInit, OnDestroy {
  private storedDeviceId: string;
  private workstationsDevice: WorkstationDevicesConfigurationModel;
  private storedCBCTDeviceId: string;
  private isImageDoubleClick: boolean = false;
  constructor(private fileManagerService: FileManagerService,
              private messagingService: MessagingService,
              private dialog: MatDialog,
              private globals: Globals,
              private staticDataService: StaticDataService,
              private snackbar: MatSnackBar,
              private socketService: SignalrService,
              private localStorageService: LocalStorageService,
              private dialogService: DialogService,
              private signalrService: SignalrService,
              private drawService: TdoImagingService,
              private devsService: DevicesService,
              private authServer: AuthenticationService,
              private changeDetection: ChangeDetectorRef,
              private ngZone: NgZone,
              private drawDefaultService: DrawDefaultsService) {
    window.resizeTo(screen.width, screen.height);
  }
  @ViewChild('main') mainRef: ElementRef;
  @ViewChild('mdiManager') mdiManager: TdoMdiManagerComponent;
  @ViewChildren(TdoImagingImageContainerComponent) imageContainers: QueryList<TdoImagingImageContainerComponent>;
  // @ViewChildren(AdjustmentPanelComponent) adjPanelComp: QueryList<AdjustmentPanelComponent>;

  @Output() folderMonitorNameEvent = new EventEmitter<any>();
  @Input() documents: DocumentDataModel[] = [];
  public drawParameter: cfgDrawParameter;
  public drawTextDefaults: DrawTextDefaults;
  public drawStampDefaults: DrawStampDefaults;
  public drawToolsDefaults: DrawingToolsDefaults;
  public annotationsDefaults: AnnotationDefaults;
  public drawFunctionToolsDefaults: DrawFunctionDefaults;
  public drawMagnificationDefaults: DrawMagnificationDefaults;
  public drawCanvasDefaults: DrawCanvasDefaults;
  public drawViewDetailDefaults: DrawMagnificationDefaults;
  public folderMonitorNameList: FolderMonitorName[] = [];
  public folderMonitorName: FolderMonitorName;
  selectedIndex: number = 0;

  // private _scanningService: lt.Scanning.IScanningSession;
  listOpenImages: TDOxImage[] = [];
  imagesToLoad: File[];
  isAcquiring: boolean = false;
  private isTwainSessionOpen = false;
  // Bumped whenever the top-menu's "launching TWAIN" spinner should be hidden - a counter
  // (not a boolean) so the child's input setter is guaranteed to fire even if two hide
  // requests happen in a row.
  hideTwainSpinnerTick = 0;
  annObjId = AnnotationObjectIdEnum;
  gammaVal: number = 100;
  brightnessVal: number = 0;
  contrastVal: number = 0;
  parentDocId: string;
  parentDocIdAnnotation: string;
  saveBurntAnn: boolean = true;
  isTwainServiceStarted: boolean = false;
  bDisplayMsgBox: boolean = false;
  lastFileClicked: TDOxImage;
  toothDetail: CaseTooth[] = [];

  toolsWidth: number;

  isSaveAsNew: boolean = true;
  isCropping: boolean = false;
  selectedContainer: TdoImagingImageContainerComponent;
  currentPatientID: any;
  currentPatientName: any;
  currentPatientCaseID: any;
  currentPatientCaseWorkItemID: any;
  documentID: any;
  message: string;
  msgTitle: string;
  documentTags: any[] = [];
  docId: any;
  imageViewer = Globals.imageViewer;
  isReady = false;
  fromOrganizer: OrganizerOpenInImagingModel;
  tagsToSet: string[];
  isMultipleCaseItem: boolean = false;

  private selectedCategories: EnumValidValueItemModel[];

  /** When Studio is already open and the landing page sets a new tags-imaging value, pick it up immediately. */
  private readonly onTagsImagingStorage = (e: StorageEvent): void => {
    if (e.key !== 'tags-imaging' || !e.newValue || e.newValue === 'null') {
      return;
    }
    try {
      const tags = JSON.parse(e.newValue) as string[];
      if (tags && tags.length > 0) {
        this.tagsToSet = tags;
        localStorage.setItem('tags-imaging', JSON.stringify(null));
      }
    } catch {
      /* ignore */
    }
  };

  /** When Studio is already open and the landing page sets open-in-imaging (e.g. double-click pre/post-op), load the image immediately. */
  private readonly onOpenInImagingStorage = (e: StorageEvent): void => {
    if (e.key !== 'open-in-imaging' || !e.newValue) {
      return;
    }
    try {
      const model = JSON.parse(e.newValue) as OrganizerOpenInImagingModel;
      if (model?.documents?.length > 0) {
        this.ngZone.run(() => {
          this.fromOrganizer = model;
          localStorage.removeItem('open-in-imaging');
          this.loadImagesFromOrganizer();
        });
      }
    } catch {
      /* ignore */
    }
  };
  private msgSub: Subscription;
  private totalScannedPages: number = 0;
  private lastPageNumber: number = 0;

  // set to false if saving all
  isDisplayClosingMsgBox = true;
  // if bClose = true - save and close document
  // if bSaveLocal = true - save and download document to local computer
  // if bDisplayMsgBox = true save and display a message box after saving
  isShowBadge: boolean;
  private initFolderMonitorInterval: number | null = null;
  devicesList: DeviceConfigurationModel[];
  enumDeviceTwain: string = '00000261-1000-0000-0000-000000000001';
  enumDeviceSB: string = '00000261-1000-0000-0000-000000000002';
  selectedDevice: DeviceConfigurationModel;
  documentTagList: EnumValidValueItemModel[];
  messageUser: EventEmitter<SocketMessageModel> = new EventEmitter<SocketMessageModel>();

  @HostListener('window:beforeunload', [ '$event' ])
     beforeUnloadHandler(event) {
      if (this.isShowBadge === true) {
        event.preventDefault();
        this.stopAllFolderMonitors();
        if (this.isImageSave() === false) {
          event.preventDefault();
          this.dialogService.openConfirmDialog('You have unsaved image(s) open. Close or save image(s) first before closing Studio.', false, false).subscribe((isConfirmed) => {
            if (isConfirmed) {
            }
          });
        }
      }
    }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    // Add visual feedback
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
  }

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    // Add visual feedback for drag enter
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!event.dataTransfer) {
      return;
    }

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      this.handleDroppedFiles(files);
    }
  }

  ngOnDestroy() {
    if (this.initFolderMonitorInterval !== null) {
      clearInterval(this.initFolderMonitorInterval);
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', this.onTagsImagingStorage);
      window.removeEventListener('storage', this.onOpenInImagingStorage);
    }
    if (this.drawService?.scanningService) {
      this.drawService.scanningService.stop();
    }
  }

  isImageSave(): boolean
  {
    let isSave = true;
    const len = this.listOpenImages.length;
    for (let i = 0; i < len; i++) {
      if (this.listOpenImages[i].bImageSaved === false) {
        isSave = false;
        break;
      }
    }
    return isSave;
  }

  async ngOnInit() {
    // $.now was removed in jQuery 3.3+ but Leadtools.Scanning.js still calls it internally
    const jq = (window as any).$;
    if (jq && !jq.now) { jq.now = Date.now; }

    if (this.globals.WorkStationName !== 'WSTEST') {
      this.isServiceBrokerRunning();
    }
    this.globals.currentPatientCaseWorkItemID = localStorage.getItem('currentPatientCaseWorkItemIDForStudio');
    this.isImageDoubleClick = false;

    this.getDevices();
    this.getDevicefromLocalStorage('IMAGE_ACQUIRE_DEVICE');
    this.getDevicefromLocalStorage('IMAGE_ACQUIRE_CBCT_DEVICE');
    // Retrieving Draw Defaults
    const promises: any[] = [
      this.drawDefaultService.getAllDrawDefaults().toPromise(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      if (results[0]) {
        // DEFAULT_TEXT_TOOLS
        let drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_TEXT_TOOLS');
        if (drawDefault) {
          this.drawTextDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_TEXT_TOOLS');
        }
        // DEFAULT_STAMP
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_STAMP');
        if (drawDefault) {
          this.drawStampDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_STAMP');
        }
        // DEFAULT_GENERAL
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_GENERAL');
        if (drawDefault) {
          this.annotationsDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_GENERAL');
        }
        // DEFAULT_DRAWING_TOOLS
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_DRAWING_TOOLS');
        if (drawDefault) {
          this.drawToolsDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_DRAWING_TOOLS');
        }
        // DEFAULT_FUNCTION_TOOLS
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_FUNCTION_TOOLS');
        if (drawDefault) {
          this.drawFunctionToolsDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_FUNCTION_TOOLS');
        }
        // DEFAULT_MAGNIFICATIONTOOLS
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_MAGNIFICATIONTOOLS');
        if (drawDefault) {
          this.drawMagnificationDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_MAGNIFICATIONTOOLS');
        }
        // DEFAULT_VIEWDETAILTOOLS
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_VIEWDETAILTOOLS');
        if (drawDefault) {
          this.drawViewDetailDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_VIEWDETAILTOOLS');
        }
        // DEFAULT_CANVASTOOLS
        drawDefault = results[0].find(p => p.ParameterName === 'DEFAULT_CANVASTOOLS');
        if (drawDefault) {
          this.drawCanvasDefaults = JSON.parse(drawDefault.ParameterValue);
        } else {
          this.setDefaultValues('DEFAULT_CANVASTOOLS');
        }

      }
      else {
        console.log('Missing draw defaults.');
      }
      this.fromOrganizer = JSON.parse(localStorage.getItem('open-in-imaging'));
      if (!this.fromOrganizer || (this.fromOrganizer && !this.fromOrganizer.documents)) {
        this.documents = [];
      } else {
        this.loadImagesFromOrganizer();
      }

    } catch (err) {
      console.log('Error retrieving draw defaults from the database!!!');
    }
    // End Draw Defaults
    const ivl = setInterval(() => {
      if (this.imageContainers) {
        clearInterval(ivl);
        this.imageContainers.changes.subscribe(() => {
          if (this.imageContainers.length > 0) {
            this.selectedContainer = this.imageContainers[this.imageContainers.length - 1];
          }
        });
      }
    }, 100);

    if (typeof window !== 'undefined') {
      window.addEventListener('storage', this.onTagsImagingStorage);
      window.addEventListener('storage', this.onOpenInImagingStorage);
    }

    // if no device is configured no need for service broker. Check devices first
    this.getAttachedDevices();
    // this.drawService.initServiceBroker(false, true);
    // this.drawService.initServiceBroker();

    this.ngZone.run(() => {
      let ticks = 0;
      this.initFolderMonitorInterval = setInterval(_ => {
        ticks++;
        if (this.drawService.folderMonitorRunning !== '' || ticks > 50) {
          clearInterval(this.initFolderMonitorInterval);
          this.initFolderMonitorInterval = null;
          if (this.drawService.folderMonitorRunning.toLowerCase() === 'true') {
            this.isShowBadge = true;
          }
          else {
            this.isShowBadge = false;
          }
          this.changeDetection.detectChanges();
        }
      },  100);
    });

    // get tooth number from currentPatientCaseWorkItemID or currentPatientCase
    if (this.globals.currentPatientCaseWorkItemID === '' || this.globals.currentPatientCaseWorkItemID === 'null' ||
      this.globals.currentPatientCaseWorkItemID === null || this.globals.currentPatientCaseWorkItemID === undefined) {
      this.currentPatientCaseWorkItemID = Constants.emptyGuid;
    } else {
      this.currentPatientCaseWorkItemID = this.globals.currentPatientCaseWorkItemID;
    }
    if(this.currentPatientCaseWorkItemID === Constants.emptyGuid){
      this.isMultipleCaseItem = true;
    }
    if (this.globals.currentPatientCaseId !== null) {
      this.drawService.getCaseTooth(this.globals.currentPatientCaseId, this.currentPatientCaseWorkItemID,
        this.globals.currentToothNumberingId).subscribe((caseToothModelResponse) => {

        if (caseToothModelResponse) {
          console.log('caseToothModelResponse ', caseToothModelResponse);
          this.toothDetail = caseToothModelResponse;
          if (Object.keys(caseToothModelResponse).length === 0) {
            console.log('No tooth');
          }
        }

        this.ngZone.run(() => this.isReady = true);
      }, error => {
        this.ngZone.run(() => this.isReady = true);
      });
    }
    //const emptyGuid = '00000000-0000-0000-0000-000000000000';
    this.socketService.messageUser.subscribe(async (sockRes) => {
      switch (sockRes.messageType) {
        case SignalrService.REFRESH_IMAGING:
          if (sockRes.message['patientId'] === this.globals.currentPatientId) {
            this.fromOrganizer = JSON.parse(localStorage.getItem('open-in-imaging'));
            // console.log('oninit socketService.messageUser this.fromOrganizer ', this.fromOrganizer);
            this.loadImagesFromOrganizer();
          }
          break;
        case 'brokerImageData':
          const obj = JSON.parse(sockRes.message as unknown as string);
          if (obj.type === 'document-saved') {
            // Post-upload confirmation sent to organizer — not an image payload, ignore here
          } else if (obj.documentId === 'UPDATE_PATIENT_PICTURE') {
            // send message UPDATE_PATIENT_PICTURE to refresh Landing Page
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', {patientId: this.globals.currentPatientId});
          } else if (obj.documentId === 'FOLDER_MONITOR_STOP') {
            // turn off badge
            this.isShowBadge = false;
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, 'FOLDER_MONITOR_CHECK', {patientId: this.globals.currentPatientId});
          } else {
            if (this.tagsToSet != null && this.tagsToSet.length > 0 && this.tagsToSet[0] === '0000001D-1000-0000-0000-000000000001') {
              this.openFileFromServiceBroker(obj.imgData, obj.documentId, obj.thumbnailDocumentId, this.tagsToSet, obj.selectedTeeth);
            } else {
              this.openFileFromServiceBroker(obj.imgData, obj.documentId, obj.thumbnailDocumentId, obj.tags, obj.selectedTeeth);
            }
            // If a TWAIN session is open, the image just arrived via WebSocket (async path).
            // Close the session now so the source is free for the next acquisition.
            this.closeTwainSession();
          }
          break;
      }
    });
    this.currentPatientName = this.globals.currentPatientFullName;
    this.currentPatientID = this.globals.currentPatientId;
    this.currentPatientCaseID = this.globals.currentPatientCaseId;
    this.currentPatientCaseWorkItemID = this.globals.currentPatientCaseWorkItemID;
    this.documentTags = [];
  }

  ngAfterViewInit() {
    this.toolsWidth = this.mainRef.nativeElement.getBoundingClientRect().width;
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => this.documentTagList = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag')
      });
    } else {
      this.documentTagList = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag');
    }
  }

  /***** SET DRAW DEFAULTS ****************************************************************************************************************
   ****************************************************************************************************************************************/
  getDrawParameters(parameterName: string) {
    const promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }
  // Get draw parameters from db
  getDrawParam(parameterName: string, callback) {
    this.getDrawParameters(parameterName)
      .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if (result === null){

          this.setDefaultValues(parameterName);
        }
        else {

          switch (parameterName) {
            case 'DEFAULT_TEXT_TOOLS':
              this.drawTextDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_STAMP':
              this.drawStampDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_GENERAL':
              this.annotationsDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_DRAWING_TOOLS':
              this.drawToolsDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_FUNCTION_TOOLS':
              this.drawFunctionToolsDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_MAGNIFICATIONTOOLS':
              this.drawMagnificationDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_VIEWDETAILTOOLS':
              this.drawViewDetailDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
            case 'DEFAULT_CANVASTOOLS':
              this.drawCanvasDefaults = JSON.parse(this.drawParameter.ParameterValue);
              break;
          }
        }
      }, err => {
        this.setDefaultValues(parameterName);
      });
    setTimeout(() => {
      callback();
    }, 200);

  }
  setDefaultValues(paramName: string) {
    switch (paramName) {
      case 'DEFAULT_TEXT_TOOLS':
          this.setTextToolsDefaults();
          break;
      case 'DEFAULT_STAMP':
        this.setStampDefaults();
        break;
      case 'DEFAULT_GENERAL':
        this.setDrawingDefaults();
        break;
      case 'DEFAULT_DRAWING_TOOLS':
        this.setDrawingToolsDefaults();
        break;
      case 'DEFAULT_FUNCTION_TOOLS':
        this.setFunctionToolsDefaults();
        break;
      case 'DEFAULT_MAGNIFICATION_TOOLS':
        this.setMagnificationToolsDefaults();
        break;
      case 'DEFAULT_VIEW_DETAIL_TOOLS':
        this.setViewDetailDefaults();
        break;
      case 'DEFAULT_CANVASTOOLS':
        this.setCanvasDefaults();
        break;
    }
  }
  setTextToolsDefaults() {
    // Text
    this.drawTextDefaults = new DrawTextDefaults();
    this.drawTextDefaults.fontTxt = 1;
    this.drawTextDefaults.fontNameTxt = 'Verdana';
    this.drawTextDefaults.fontSizeTxt = 18;
    this.drawTextDefaults.fontStyleTxt = '0';
    this.drawTextDefaults.foregroundTxt = '#f05b41';
    this.drawTextDefaults.backgroundTxt = 'Transparent';
    this.drawTextDefaults.borderColorTxt = '#417CF0';
    this.drawTextDefaults.lineWidthTxt = 3;
    // TxtPtr
    this.drawTextDefaults.fontTxtPtr = 1;
    this.drawTextDefaults.fontNameTxtPtr = 'Verdana';
    this.drawTextDefaults.fontSizeTxtPtr = 18;
    this.drawTextDefaults.fontStyleTxtPtr = '0';
    this.drawTextDefaults.foregroundTxtPtr = '#f05b41';
    this.drawTextDefaults.backgroundTxtPtr = 'Transparent';
    this.drawTextDefaults.borderColorTxtPtr = '#417CF0';
    this.drawTextDefaults.lineWidthTxtPtr = 3;
  }
  setStampDefaults() {
    this.drawStampDefaults = new DrawStampDefaults();
    // Standard Stamp
    this.drawStampDefaults.fontStdStamp = 1;
    this.drawStampDefaults.fontNameStdStamp = 'Verdana';
    this.drawStampDefaults.fontSizeStdStamp = 12;
    this.drawStampDefaults.fontStyleStdStamp = '0';
    this.drawStampDefaults.foregroundStdStamp = '#f05b41';
    this.drawStampDefaults.backgroundStdStamp = '#5341f0';
    this.drawStampDefaults.locationStdStamp = '4';
    // Custom Stamp
    this.drawStampDefaults.fontCustomStamp = 1;
    this.drawStampDefaults.fontNameCustomStamp = 'Verdana';
    this.drawStampDefaults.fontSizeCustomStamp = 12;
    this.drawStampDefaults.fontStyleCustomStamp = '0';
    this.drawStampDefaults.foregroundCustomStamp = '#f05b41';
    this.drawStampDefaults.foregroundCustomStamp = '#5341f0';
  }
  setDrawingToolsDefaults() {
    this.drawToolsDefaults = new DrawingToolsDefaults();
    this.drawToolsDefaults.arrowLength = 50;
    this.drawToolsDefaults.useRatioArrowLen = false;
    this.drawToolsDefaults.fillArrowhead = false;

  }
  setDrawingDefaults() {
    this.annotationsDefaults = new AnnotationDefaults();
    this.annotationsDefaults.strokeColor = '#f05b41';
    this.annotationsDefaults.fillColor = '#f05b41';
    this.annotationsDefaults.strokeWidth = 2;
    this.annotationsDefaults.fontSize = 12;
    this.annotationsDefaults.font = '0';
    this.annotationsDefaults.fontName = 'Arial';
    this.annotationsDefaults.lineStartCap = 0;
    this.annotationsDefaults.lineEndCap = 0;
    this.annotationsDefaults.fontStyle = 0;
  }
  setFunctionToolsDefaults() {
    this.drawFunctionToolsDefaults = new DrawFunctionDefaults();
    this.drawFunctionToolsDefaults.font = 'Verdana';
    this.drawFunctionToolsDefaults.fontSize = 12;
    this.drawFunctionToolsDefaults.fontStyle = '0';
    this.drawFunctionToolsDefaults.foreground = '#f05b41';
    this.drawFunctionToolsDefaults.background = '#5341f0';
    this.drawFunctionToolsDefaults.showTickMarks = true;
    this.drawFunctionToolsDefaults.showGauge = true;
  }
  setMagnificationToolsDefaults() {
    this.drawMagnificationDefaults = new DrawMagnificationDefaults();
    this.drawMagnificationDefaults.shape = 'RoundRectangle';
    this.drawMagnificationDefaults.width = 300;
    this.drawMagnificationDefaults.height = 300;
    this.drawMagnificationDefaults.borderColor = '#f05b41';
    this.drawMagnificationDefaults.borderWidth = 3;
    this.drawMagnificationDefaults.lineStartCap = 'Square';
    this.drawMagnificationDefaults.lineEndCap = 'Square';
    this.drawMagnificationDefaults.hasCrosshairs = true;
    this.drawMagnificationDefaults.crosshairsColor = '#5341f0';
    this.drawMagnificationDefaults.crosshairWidth = 1;
    this.drawMagnificationDefaults.scaleFactor = 3;
  }
  setViewDetailDefaults() {
    this.drawViewDetailDefaults = new DrawMagnificationDefaults();
    this.drawViewDetailDefaults.shape = 'RoundRectangle';
    this.drawViewDetailDefaults.width = 300;
    this.drawViewDetailDefaults.height = 300;
    this.drawViewDetailDefaults.borderColor = '#f05b41';
    this.drawViewDetailDefaults.borderWidth = 3;
    this.drawViewDetailDefaults.lineStartCap = 'Square';
    this.drawViewDetailDefaults.lineEndCap = 'Square';
    this.drawViewDetailDefaults.hasCrosshairs = true;
    this.drawViewDetailDefaults.crosshairsColor = '#5341f0';
    this.drawViewDetailDefaults.crosshairWidth = 1;
    // this.drawViewDetailDefaults.scaleFactor = 3;
  }

  setCanvasDefaults() {
    this.drawCanvasDefaults = new DrawCanvasDefaults();
    this.drawCanvasDefaults.width = 300;
    this.drawCanvasDefaults.height = 300;
    this.drawCanvasDefaults.startColor = '#ff0000';
    this.drawCanvasDefaults.endColor = '#ffffff';
    this.drawCanvasDefaults.gradientStep = 1;
    this.drawCanvasDefaults.gradientStyle = 1;
  }

  /***** EVENT HANDLING ********************************************************************************************************************
   ****************************************************************************************************************************************/
  onDrawingToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.DRAWING_TOOL_POINTER:
        this.btnClickAnnotationObj(this.annObjId[0]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_LINE:
        this.btnClickAnnotationObj(this.annObjId[1]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_RECTANGLE:
        this.btnClickAnnotationObj(this.annObjId[2]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_CIRCLE:
        this.btnClickAnnotationObj(this.annObjId[3]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_ARROW:
        this.btnClickAnnotationObj(this.annObjId[4]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_FILLED_RECTANGLE:
        this.btnClickAnnotationObj(this.annObjId[5]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_MULTI_POINT_LINE:
        this.btnClickAnnotationObj(this.annObjId[6]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_SPRAY_CAN:
        console.log('Spraycan tool clicked');
        break;
      case ImagingToolEvent.DRAWING_TOOL_PEN:
        this.btnClickAnnotationObj(this.annObjId[12]);
        break;
      case ImagingToolEvent.DRAWING_TOOL_FILL:
        this.btnClickFillRegion();
        break;
    }
  }

  onOrientationToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.ORIENTATION_TOOL_FLIP_HORIZONTAL:
        this.btnFlip(180);
        break;
      case ImagingToolEvent.ORIENTATION_TOOL_FLIP_VERTICAL:
        this.btnFlip(0);
        break;
      case ImagingToolEvent.ORIENTATION_TOOL_ROTATE_NINETY:
        this.btnFlip(90);
        break;
      case ImagingToolEvent.ORIENTATION_TOOL_ROTATE_180:
        this.btnFlip(1);
        break;
      case ImagingToolEvent.ORIENTATION_TOOL_ROTATE:
        this.btnMagnification(4);
        break;
      case ImagingToolEvent.ORIENTATION_TOOL_ROTATE_END:
        this.btnMagnification(5);
        break;
    }
  }

  onCanvasToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.CANVAS_TOOL_FILE_1:
        this.createBlankCanvas( 'WhiteCanvas', false);
        break;
      case ImagingToolEvent.CANVAS_TOOL_FILE_2:
        console.log('Canvas file 2 clicked');
        this.createBlankCanvas( 'BlackCanvas', false);
        break;
      case ImagingToolEvent.CANVAS_TOOL_FILE_3:
        console.log('Canvas file 3 clicked');
        this.createBlankCanvas( 'GradientCanvas', false);
        break;
      case ImagingToolEvent.CANVAS_TOOL_INVERT_SELECTION:
        console.log('Canvas invert selection clicked');
        this.btnInvert();
        break;
      case ImagingToolEvent.CANVAS_TOOL_INVERT_COLOR:
        console.log('Canvas invert color clicked');
        this.btnGrayscale();
        break;
    }
  }

  onAdjustmentToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.ADJUSTMENT_TOOL_CROP:
        this.onCrop();
        break;
      case ImagingToolEvent.ADJUSTMENT_TOOL_SUN:
        console.log('Adjustment sun');
        this.onAdjustmentPanel();
        break;
      case ImagingToolEvent.ADJUSTMENT_TOOL_FLASHLIGHT:
        this.dialogService.openConfirmDialog('Coming Soon!', false, false, 'Coming Soon!').subscribe((result) => {
          if (result === true) {
          }
        });
        console.log('Adjustment flashlight');
        break;
      case ImagingToolEvent.ADJUSTMENT_TOOL_TUNE:
        console.log('Adjustment tune');
        this.dialogService.openConfirmDialog('Coming Soon!', false, false, 'Coming Soon!').subscribe((result) => {
          if (result === true) {
          }
        });
        break;
      case ImagingToolEvent.ADJUSTMENT_TOOL_FILTRATION:
        console.log('Adjustment filtration');
        this.dialogService.openConfirmDialog('Coming Soon!', false, false, 'Coming Soon!').subscribe((result) => {
          if (result === true) {
          }
        });
        break;
      case ImagingToolEvent.ADJUSTMENT_TOOL_AUTOMATIC_GEARBOX:
        this.dialogService.openConfirmDialog('Coming Soon!', false, false, 'Coming Soon!').subscribe((result) => {
          if (result === true) {
          }
        });
        console.log('Adjustment gearbox');
        break;
    }
  }

  onTextToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.TEXT_TOOL_TYPE:
        console.log('Text type');
        this.btnClickAnnotationObj(this.annObjId[7]);
        break;
      case ImagingToolEvent.TEXT_TOOL_TEXT_BOX:
        console.log('Text text box');
        this.btnClickAnnotationObj(this.annObjId[8]);
        break;
      case ImagingToolEvent.TEXT_TOOL_STAMP_1:
        this.btnClickAnnotationObj('standard-stamp');
        break;
      case ImagingToolEvent.TEXT_TOOL_STAMP_2:
        console.log('Text tool stamp 2');
        this.btnClickAnnotationObj('Stamp');
        break;
    }
  }

  onMagnificationToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.MAGNIFICATION_TOOL_RING_DETAILS:
        // Details
        this.btnMagnification(3);
        break;
      case ImagingToolEvent.MAGNIFICATION_TOOL_ZIPPER_SLIDER:
        this.btnMagnification(0);
        break;
      case ImagingToolEvent.MAGNIFICATION_TOOL_ANALYZE:
        this.btnMagnification(2);
        break;
      case ImagingToolEvent.MAGNIFICATION_TOOL_ZOOM_IN:
        // Magnifying glass
        this.btnMagnification(1);
        break;
      case ImagingToolEvent.MAGNIFICATION_TOOL_PREVIEW_PANE:
        this.btnMagnification(0);
        break;
    }
  }

  onFunctionToolEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.FUNCTION_TOOL_RULER:
        this.btnClickAnnotationObj(this.annObjId[10]);
        break;
      case ImagingToolEvent.FUNCTION_TOOL_LIPIDS:
        this.btnClickAnnotationObj(this.annObjId[11]);
        break;
      case ImagingToolEvent.FUNCTION_TOOL_UNDO:
        this.btnClickUndo(0);
        break;
      case ImagingToolEvent.FUNCTION_TOOL_CLEAR:
        this.btnClickUndo(1);
        break;
      case ImagingToolEvent.FUNCTION_TOOL_REVERT:
        this.btnClickRevert();
        break;
    }
  }

  isFolderMonitorRunning() {
    this.drawService.folderMonitorRunning = '';
    this.callServiceBroker('is-folder-monitor-running',  () => {
      this.ngZone.run(() => {
        let ticks = 0;
        const intervalSubscription = setInterval(_ => {
          ticks++;
          if (this.drawService.folderMonitorRunning !== '' || ticks > 50) {
            clearInterval(intervalSubscription);
            if (this.drawService.folderMonitorRunning.toLowerCase() === 'true') {
              this.isShowBadge = true;
            }
            else {
              this.isShowBadge = false;
            }
            this.changeDetection.detectChanges();
          }
        },  100);
      });
    });

  }
  onTopMenuEvent(event: ImagingTopMenuEvent) {
    console.log('onTopMenuEvent', event);
    switch (event.type) {
      case ImagingTopMenuEvent.INNER_JOIN_LEFT:
        this.mdiManager.setEmphasizeLeft();
        break;
      case ImagingTopMenuEvent.OUTER_JOIN_RIGHT:
        this.mdiManager.setEmphasizeRight();
        break;
      case ImagingTopMenuEvent.COMPARE:
        this.mdiManager.setItemsEqual();
        break;
      case ImagingTopMenuEvent.CASCADE:
        //localStorage.setItem('imaging-layout', 'cascade');
        this.mdiManager.setCascade();
        break;
      case ImagingTopMenuEvent.TILE:
        //localStorage.setItem('imaging-layout', 'tile');
        this.mdiManager.setTile(event.tileMax);
        break;
      case ImagingTopMenuEvent.CATEGORIES:
        this.selectedCategories = event.categories;
        if (this.selectedContainer) {
          //const selectedTagIds = this.selectedCategories.map(p => p.ValidValueItemId);
          const currentTags = this.selectedContainer.document?.dataDocumentTags ?? [];
          const currentTagIds = currentTags.map(p => p.enumDocumentTagID);
          const tagsToSave = this.selectedCategories.filter(p => !currentTagIds.includes(p.ValidValueItemId));
          const tagIdsToSave = tagsToSave.map(p => p.ValidValueItemId);
          if (tagIdsToSave.includes('0000001D-1000-0000-0000-000000000001') || tagIdsToSave.includes('0000001d-1000-0000-0000-000000000001')) {
            this.signalrService.messageAllUsers(SignalrService.UPDATE_PROFILE, {patientId: this.globals.currentPatientId});
          }
          this.selectedContainer.saveTags(tagIdsToSave);
        }
        break;
      case ImagingTopMenuEvent.OPEN_FILE:
        this.imagesToLoad = event.selectedFiles;
        this.openFile(this.imagesToLoad.shift());
        break;
      case ImagingTopMenuEvent.ADD_IMAGE:
        console.log('add image called');
        // this.openFiles.push('2');
        break;
      case ImagingTopMenuEvent.SAVE:
        if (this.selectedContainer.xImage.imageSource.includes('Canvas') && !this.selectedContainer.xImage.AutoSave) {
          this.isSaveAsNew = true;
          // set flag that image has been saved the first time
          this.selectedContainer.xImage.AutoSave = true;
        }
        else {
          this.isSaveAsNew = false;
        }
        // console.log('OnTopMenuEvent: save: isSaveAsNew', this.isSaveAsNew);
        this.onLTSave(false, false, true, () => {
          // this.selectedContainer = null;
          setTimeout(() => {
            // this.selectedContainer = this.imageContainers[this.imageContainers.length - 1];
          }, 10);
        });
        break;
      case ImagingTopMenuEvent.SAVE_AS_NEW:
        if (this.selectedContainer.xImage.imageSource.includes('Canvas')) {
          // set flag that image has been saved the first time
          this.selectedContainer.xImage.AutoSave = true;
        }
        this.isSaveAsNew = true;
        this.onLTSave(false, false, true, () => {
          // this.selectedContainer = null;
          setTimeout(() => {
            // this.selectedContainer = this.imageContainers[this.imageContainers.length - 1];
          }, 10);
        });
        break;
      case ImagingTopMenuEvent.SAVE_DOWNLOAD:
        this.isSaveAsNew = true;
        // console.log('save and download');
        this.onLTSave(false, true, true, () => {
        });
        break;
      case ImagingTopMenuEvent.SAVE_CLOSE:
        this.isSaveAsNew = true;
        this.onLTSave(true, false, true, () => {
        });
        break;
      case ImagingTopMenuEvent.SAVE_ALL:
        this.onSaveAll();
        break;
      case ImagingTopMenuEvent.SAVE_LIB_LEC:
        this.onSaveLibLec(event.folderIds);
        break;
      case ImagingTopMenuEvent.PRINT:
        // console.log('print');
        this.dialogService.openConfirmDialog('Coming Soon!', false, false, 'Coming Soon!').subscribe((result) => {
          if (result === true) {
          }
        });
        break;
      case ImagingTopMenuEvent.CAMERA:
        // this.onOpenDesktopAcquire('run_folder_monitor');
        this.callServiceBroker('start-folder-monitor',  () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
            }
          },  100);
        });
        break;
      case ImagingTopMenuEvent.PORTRAIT:
        const tags: string[] = [];
        // Patient Picture tag
        tags.push('0000001D-1000-0000-0000-000000000001');
        this.tagsToSet = tags;
        this.callServiceBroker('camera', () => {
            const intervalSubscription = setInterval(_ => {
              if (true) {
                clearInterval(intervalSubscription);
              }
            }, 100);
          }, '', event.folderMonitorName);
        break;
      case ImagingTopMenuEvent.STOP_CAMERA:
        this.callServiceBroker('stop-folder-monitor',  () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
              this.isFolderMonitorRunning();
            }
          },  100);
        }, '', event.folderMonitorName);
        break;
      case ImagingTopMenuEvent.STOP_CAMERA_PORTRAIT:
        this.callServiceBroker('stop-folder-monitor_portrait',  () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
              this.isFolderMonitorRunning();
            }
          },  100);
        }, '', event.folderMonitorName);
        break;
      case ImagingTopMenuEvent.START_CAMERA:
        // DSLR devices have their own tethering software that writes into the monitored
        // folder directly - they don't work with the Windows Camera app. Categories without
        // dedicated acquire flows (e.g. Microscope) are generic webcam-type devices, so those
        // get the Windows Camera app launched via the 'camera' command.
        const knownNonCameraLaunchCategories = [
          DEVICE_CATEGORY.DSLRCamera, DEVICE_CATEGORY.Scanner, DEVICE_CATEGORY.Radiology,
          DEVICE_CATEGORY.CBCTCarestream, DEVICE_CATEGORY.Portrait, DEVICE_CATEGORY.Printer
        ];
        const shouldLaunchCameraApp = !knownNonCameraLaunchCategories.includes(event.deviceCategoryId);
        this.callServiceBroker(shouldLaunchCameraApp ? 'camera' : 'start-folder-monitor',  () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
              this.isFolderMonitorRunning();
            }
          },  100);
        }, event.deviceCategoryId, event.folderMonitorName);
        break;
      case ImagingTopMenuEvent.START_CAMERA_PORTRAIT:
        this.callServiceBroker('start-folder-monitor-portrait',  () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
              this.isFolderMonitorRunning();
            }
          },  100);
        }, event.deviceCategoryId, event.folderMonitorName);
        break;
      case ImagingTopMenuEvent.DESKTOP_ACQUIRE:
        this.callServiceBroker('open_desk_top_acquire', () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
            }
          },  100);
        });
        break;
      case ImagingTopMenuEvent.XRAY:
        this.onXray();
        break;

      case ImagingTopMenuEvent.SCANNER:
        // console.log('mtm scanner');
        this.onXray();
        break;

      case ImagingTopMenuEvent.CBCT:
        this.onCBCT();
        break;

      case ImagingTopMenuEvent.CONFIGURE_TWAIN:
        this.openTwainSelectionDialog('Select TWAIN Driver');
        break;
    }
  }

  onAttributeEvent(event: ImagingToolEvent) {
    switch (event.type) {
      case ImagingToolEvent.BRIGHTNESS:
        this.onBrightnessChange(event.value);
        break;
      case ImagingToolEvent.CONTRAST:
        this.onContrastChange(event.value);
        break;
      case ImagingToolEvent.GAMMA:
        this.onGammaChange(event.value);
        break;
      case ImagingToolEvent.USE_MOUSE:
        this.onUseMouse(event.value);
        break;
      case ImagingToolEvent.LINE_SIZE:
        this.onChangeLineSize(event.value);
        break;
      case ImagingToolEvent.COLOR:
        this.onChangeLineColor(event.value);
        break;
      case ImagingToolEvent.TEXT_COLOR:
        this.onChangeTextColor(event.value);
        break;
    }
  }

  onUseMouse(useMouse) {
    if (useMouse) {
      this.onImgProcessing(5);
    } else {
      this.onImgProcessing(6);
    }
  }

  setGammaValue(value) {
    // console.log('gamma = ' + value);
    this.gammaVal = value;
    this.listOpenImages[this.selectedIndex].gammaVal = value;
  }

  setBrightnessValue(value) {
    // console.log('brightness = ' + value);
    this.brightnessVal = value;
    // this.listOpenImages[this.selectedIndex].brightnessVal = value;
  }

  setContrastValue(value) {
    // console.log('contrast = ' + value);
    this.contrastVal = value;
    // this.listOpenImages[this.selectedIndex].contrastVal = value;
  }

  onChangeLineSize(widthSize) {
    Globals.annotationsDefaults.strokeWidth = widthSize;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.changeLineSizeColor(widthSize, Globals.annotationsDefaults.strokeColor);
      }
    });
  }

  onChangeLineColor(strokeColor) {
    Globals.annotationsDefaults.strokeColor = strokeColor;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.changeLineSizeColor(Globals.annotationsDefaults.strokeWidth, strokeColor);
      }
    });
  }
  onChangeTextColor(textColor) {
    Globals.annotationsDefaults.textColor = textColor;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.changeTextColor(textColor);
      }
    });
  }

  onContrastChange(contrastVal) {
    this.contrastVal = contrastVal;
    if (this.listOpenImages.length > 0) {
      this.listOpenImages[this.selectedIndex].contrastVal = contrastVal;
      this.imageContainers.forEach(component => {
        if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
          component.imgContrast(contrastVal, this.listOpenImages[this.selectedIndex].URL);
        }
      });
    }
  }

  onBrightnessChange(brightnessVal) {
    this.brightnessVal = brightnessVal;
    if (this.listOpenImages.length > 0) {
      this.listOpenImages[this.selectedIndex].brightnessVal = brightnessVal;
      this.imageContainers.forEach(component => {
        if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
          component.imgBrightness(brightnessVal, this.listOpenImages[this.selectedIndex].URL);
        }
      });
    }
  }

  onGammaChange(gammaVal) {
    this.gammaVal = gammaVal;
    if (this.listOpenImages.length > 0) {
      this.listOpenImages[this.selectedIndex].gammaVal = gammaVal;
      this.imageContainers.forEach(component => {
        if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
          component.imgGamma(gammaVal, this.listOpenImages[this.selectedIndex].URL);
        }
      });
    }
  }

  onSharpness(sharpnessVal) {
    // console.log('onSharpness sharpness = ' + sharpnessVal);
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.imgSharpness(sharpnessVal);
      }
    });
  }

  onAdjustmentPanel() {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.onImgProcessing(5);
    /*this.adjPanelComp.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.init();
      }
    });*/
  }

  onImgProcessing(mode) {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.onMagnification(mode);
      }
    });
  }

  btnMagnification(mode) {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        if (mode === 5) {
          component.stopRotation();
        } else if (mode === 6) {
          component.resetRotation();
        } else if (mode === 7) {
          component.cancelRotation();
        } else {
          component.isRotation = false;
          component.onMagnification(mode);
        }
      }
    });
  }

  onCrop() {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.isRotation = false;
        component.crop();
      }
    });
  }

  btnFlip(angle) {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.isRotation = false;
        component.flip(angle);
      }
    });
  }
  btnInvert() {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.isRotation = false;
        component.invert();
      }
    });
  }
  btnGrayscale() {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.isRotation = false;
        component.grayScale();
      }
    });
  }
  /**
   * Studio opened from the recall form carries the recall tag in fromOrganizer.tags, but tagsToSet can still be
   * empty when an acquisition starts: a stored IMAGE_ACQUIRE_CBCT_DEVICE resets it to [] on init, the device can be
   * clicked before getAttachedDevices -> processDeviceConfiguration has run, and on a Studio reload the previous
   * window's storage listener has already consumed tags-imaging. Fall back to the launcher's tags so the acquired
   * x-ray isn't saved as General. Only the recall document viewer sets fromOrganizer.tags.
   */
  private applyLauncherTagsIfEmpty(): void {
    if ((!this.tagsToSet || this.tagsToSet.length === 0) && this.fromOrganizer?.tags?.length) {
      this.tagsToSet = [...this.fromOrganizer.tags];
      // console.log('applyLauncherTagsIfEmpty: using launcher tags', this.tagsToSet);
    }
  }

  callServiceBroker(commandType: string, callback, deviceCategoryId: string = '', folderMonitorName: string = '') {
    const enumDeviceSBSchick = '00000b62-1000-0000-0000-000000000009';
    this.devsService.getWsDevice(this.storedDeviceId).subscribe(wsData => {
        this.workstationsDevice = wsData[0];
        //  Check what kind of device, TWAIN or Service Broker.
        //  From the DeviceId, find the enumDeviceTypeID from deviceList
        this.selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === this.workstationsDevice.DeviceID);
        if (this.selectedDevice.enumDeviceSBID === enumDeviceSBSchick){
        if (!this.globals.ThePatient.BirthDate) {
          this.dialogService.openConfirmDialog('Patient DOB is required to use Schick.', false, false, 'Patient DOB Required').subscribe((result) => {

            return;
          });
        }
      }
        this.applyLauncherTagsIfEmpty();
        const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
        desktopAcquireCommandArgs.PatientName = this.globals.currentPatientFullName;
        desktopAcquireCommandArgs.PatientNO = this.globals.ThePatient.PatientNO;
        desktopAcquireCommandArgs.PatientDOB = this.globals.ThePatient.BirthDate;
        desktopAcquireCommandArgs.Gender = this.globals.ThePatient.dataContact.enumGenderID;
        desktopAcquireCommandArgs.LocId = this.globals.LOCID;
        desktopAcquireCommandArgs.UserId = this.localStorageService.currentUserData.authdata.userid;
        desktopAcquireCommandArgs.PatientId = this.currentPatientID;
        desktopAcquireCommandArgs.ToothList = this.toothDetail;
        desktopAcquireCommandArgs.FolderMonitorName = folderMonitorName;
        if (deviceCategoryId !== '') {
          desktopAcquireCommandArgs.enumDeviceCategoryId = deviceCategoryId;
        }
        if (commandType === 'camera' || commandType === 'start-folder-monitor-portrait') {
          desktopAcquireCommandArgs.Tags = this.tagsToSet;
        }
        if (this.selectedDevice !== undefined) {
          desktopAcquireCommandArgs.enumDeviceSBId = this.selectedDevice.enumDeviceSBID;
        }
        if (this.tagsToSet != null && this.tagsToSet.length > 0 && this.tagsToSet[0] === DOCUMENT_TAG.PatientPicture) {
          // if patient picture PatientCaseId is FormsRepo
          this.fileManagerService.getCaseIdFormsRepo(this.globals.currentPatientId).subscribe((res) => {
            if (res) {
              desktopAcquireCommandArgs.PatientCaseId = res;
              this.drawService.sendServiceBrokerCommand(desktopAcquireCommandArgs, commandType);
              setTimeout(() => {
                callback();
              }, 200);
            }
          });
        }
        else {
          desktopAcquireCommandArgs.PatientCaseId = this.globals.currentPatientCaseId;
/*
          if (desktopAcquireCommandArgs.PatientCaseId === 'null') {
            this.dialogService.openConfirmDialog('You must select a procedure with a tooth case from the landing page.', false, false, 'Case ID Required').subscribe((result) => {
              return;
            });
          }
*/
          if (this.selectedCategories && this.selectedCategories.length > 0) {
            this.tagsToSet = this.selectedCategories.map(p => p.ValidValueItemId);
          }
          if (this.tagsToSet !== null) {
            desktopAcquireCommandArgs.Tags = this.tagsToSet;
          }
          this.drawService.sendServiceBrokerCommand(desktopAcquireCommandArgs, commandType);
          setTimeout(() => {
            callback();
          }, 200);
        }
    });
  }
  async callServiceBrokerAsync(commandType: string, folderMonitorName: string = '') {
    this.applyLauncherTagsIfEmpty();
    const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
    desktopAcquireCommandArgs.PatientName = this.globals.currentPatientFullName;
    desktopAcquireCommandArgs.LocId = this.globals.LOCID;
    desktopAcquireCommandArgs.UserId = this.localStorageService.currentUserData.authdata.userid;
    desktopAcquireCommandArgs.PatientId = this.currentPatientID;
    desktopAcquireCommandArgs.ToothList = this.toothDetail;
    desktopAcquireCommandArgs.FolderMonitorName = folderMonitorName;
    if (commandType === 'camera') {
      desktopAcquireCommandArgs.Tags = this.tagsToSet;
    }
    if (this.selectedDevice !== undefined) {
      desktopAcquireCommandArgs.enumDeviceSBId = this.selectedDevice.enumDeviceSBID;
    }
    if (this.tagsToSet != null && this.tagsToSet.length > 0 && this.tagsToSet[0] === DOCUMENT_TAG.PatientPicture) {
      // if patient picture PatientCaseId is FormsRepo
      this.fileManagerService.getCaseIdFormsRepo(this.globals.currentPatientId).subscribe((res) => {
        if (res) {
          desktopAcquireCommandArgs.PatientCaseId = res;
          this.drawService.sendServiceBrokerCommand(desktopAcquireCommandArgs, commandType);
        }
      });
    }
    else {
      desktopAcquireCommandArgs.PatientCaseId = this.globals.currentPatientCaseId;
      if (this.tagsToSet !== null) {
        desktopAcquireCommandArgs.Tags = this.tagsToSet;
      }

      this.drawService.sendServiceBrokerCommand(desktopAcquireCommandArgs, commandType);
    }
  }
  onXray() {
    // Figure out what device to use
    this.getDevicefromLocalStorage('IMAGE_ACQUIRE_DEVICE');
    this.getWsDeviceData();
    // this.isTwainServiceStarted = false;
    // const imgType = -1;
    // this.newXray();
  }
  onCBCT() {
    // Figure out what device to use
    this.getDevicefromLocalStorage('IMAGE_ACQUIRE_CBCT_DEVICE');
    this.getWsCBCTDeviceData();
  }
  getDevicefromLocalStorage(key: string) {
    if (key === 'IMAGE_ACQUIRE_DEVICE') {
      this.storedDeviceId = localStorage.getItem(key);
      if (!this.storedDeviceId) {
        // this.storedDeviceId is null
      } else {
        if (this.storedDeviceId === 'undefined') {
        } else {
          this.storedDeviceId = JSON.parse(this.storedDeviceId);
        }
      }
    }
    else if (key === 'IMAGE_ACQUIRE_CBCT_DEVICE') {
      this.storedCBCTDeviceId = localStorage.getItem(key);
      if (!this.storedCBCTDeviceId) {
        // Display Message Box !!!
      } else {
        if (this.storedCBCTDeviceId === 'undefined') {
        } else {
          this.tagsToSet = [];
          this.storedCBCTDeviceId = JSON.parse(this.storedCBCTDeviceId);
        }
      }
    }

  }
  getWsCBCTDeviceData() {
    this.devsService.getWsDevice(this.storedCBCTDeviceId).subscribe(wsData => {
      this.workstationsDevice = wsData[0];
      //  Check what kind of device, TWAIN or Service Broker.
      //  From the DeviceId, find the enumDeviceTypeID from deviceList
      this.selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === this.workstationsDevice.DeviceID);
      if (this.selectedDevice.enumDeviceTypeID === this.enumDeviceSB) {
        // need to send the enumDeviceSBID to service broker to determine which cbct
        // 00000B62-1000-0000-0000-000000000005 is CS CBCT
        this.callServiceBroker('open_desk_top_acquire', () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
            }
          },  100);
        });

      }
    }, err => {
      console.error(err);
    });
  }

  getWsDeviceData() {

    this.devsService.getWsDevice(this.storedDeviceId).subscribe(wsData => {
      this.workstationsDevice = wsData[0];
      //  Check what kind of device, TWAIN or Service Broker.
      //  From the DeviceId, find the enumDeviceTypeID from deviceList
      this.selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === this.workstationsDevice.DeviceID);
      if (this.selectedDevice.enumDeviceTypeID !== this.enumDeviceTwain) {
        // Top-menu optimistically shows the TWAIN spinner as soon as it's clicked (based on its
        // own device list) - correct it immediately if this device actually isn't TWAIN.
        this.hideTwainSpinnerTick++;
      }
      if (this.selectedDevice.enumDeviceTypeID === this.enumDeviceTwain) {
        // twain
        // console.log('device is Twain');
        // console.log('mtm this.workstationsDevice ', this.workstationsDevice.enumDeviceCategoryID);
        this.isTwainServiceStarted = false;
        const imgType = -1;
        // Sync IMAGE_ACQUIRE_TWAIN from the selected device's ParametersJSON before scanning.
        // Without this, the global localStorage key holds whichever TWAIN driver was configured
        // last in the workstations screen, so selecting SiTwain after CS Intraoral Twain (or
        // vice-versa) would open the wrong scanner.
        if (this.workstationsDevice.ParametersJSON) {
          try {
            const params = JSON.parse(this.workstationsDevice.ParametersJSON);
            if (params.twainDriver) {
              localStorage.setItem('IMAGE_ACQUIRE_TWAIN', JSON.stringify(params.twainDriver));
            }
          } catch (e) {
            console.error('Could not parse ParametersJSON for TWAIN driver', e);
          }
        }
        this.newXrayScanner();
      }
      else if (this.selectedDevice.enumDeviceTypeID === this.enumDeviceSB) {
        // service broker
        console.log('device is service broker');
        // reset data in local storage in case it was set from patient picture
        localStorage.setItem('is-Start-Folder-Monitor', JSON.stringify('false'));
        this.callServiceBroker('stop-folder-monitor',  () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
            }
          },  100);
        });
/*
        if (this.toothDetail) {
          if (this.toothDetail.length === 0) {
            this.dialogService.openConfirmDialog('You must select a procedure with a tooth case from the landing page.', false, false, 'Tooth Required').subscribe((result) => {

            });

            return;
          }
        }
*/
        this.callServiceBroker('open_desk_top_acquire', () => {
          const intervalSubscription = setInterval(_ => {
            if (true) {
              clearInterval(intervalSubscription);
            }
          },  100);
        });

      }
      }, err => {
      console.error(err);
    }); 
  }
  getDevices() {
    this.devsService.getDevices(this.globals.LOCID).subscribe(ddata => {
      this.devicesList = ddata;
    }, err => {
      console.error(err);
    });
  }
  getAttachedDevices() {
    console.log('inside getAttachedDevices called');
    const WorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;

    this.devsService.getAttachedDevices(WorkStationID.toString()).subscribe(ddata => {
      if (ddata.length > 0) {
        // Wait for service broker status before proceeding with device logic
        this.isServiceBrokerRunning(() => {
          this.processDeviceConfiguration(ddata);
        });
      }
      else {
        console.log('No device configured - no need for SB');
        // check for Tags to set
        console.log('3 getAttachedDevices localStorage.getItem(\'tags-imaging\')', localStorage.getItem('tags-imaging'));
        this.tagsToSet = [];
        this.tagsToSet = JSON.parse(localStorage.getItem('tags-imaging'));
        console.log('this.tagsToSet ', this.tagsToSet);
        if (this.tagsToSet !== undefined || this.tagsToSet !== null) {
          localStorage.setItem('tags-imaging', JSON.stringify(null));
        }
        else {
          this.tagsToSet = [];
          // General tag
          this.tagsToSet.push(DOCUMENT_TAG.General);
        }
        this.drawService.initServiceBroker(false, false, false);
      }
      // this.workstationDeviceList = ddata;
    }, err => {
      console.log(err);
      // return false;
    });
  }

  private processDeviceConfiguration(ddata: any[]) {
    if (this.storedDeviceId) {
      // check the device category of the selected device if portrait launch camera
      const wsSelected = ddata.find(p => p.WorkStationDeviceID.toString() === this.storedDeviceId);
      console.log('wsSelected ', wsSelected);
      if (wsSelected) {
        if (wsSelected.enumDeviceCategoryID === DEVICE_CATEGORY.Portrait) {
          this.selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === wsSelected.DeviceID);
          this.tagsToSet = [];
          // Patient Picture tag
          this.tagsToSet.push(DOCUMENT_TAG.PatientPicture);
          let folderMonitorParam;
          if (wsSelected.ParametersJSON != null) {
            folderMonitorParam = JSON.parse(wsSelected.ParametersJSON);
          } else {
            folderMonitorParam = '';
          }
          this.callServiceBrokerAsync('camera', folderMonitorParam.MonitorName);
        } else if (wsSelected.enumDeviceCategoryID === DEVICE_CATEGORY.Radiology) {
          // A stored IMAGE_ACQUIRE_CBCT_DEVICE resets tagsToSet to [] during init (getDevicefromLocalStorage),
          // so treat empty the same as undefined - otherwise the launcher's tags (e.g. recall) are dropped
          // and Service Broker defaults the acquired x-ray to General.
          if (!this.tagsToSet?.length) {
            const storedTags: string[] = JSON.parse(localStorage.getItem('tags-imaging'));
            this.tagsToSet = storedTags?.length ? storedTags : (this.fromOrganizer?.tags ?? []);
            localStorage.setItem('tags-imaging', JSON.stringify(null));
          }
        }
        // all other device set tag to general
        else {
          this.tagsToSet = [];
          console.log('1 getAttachedDevices localStorage.getItem(\'tags-imaging\')', localStorage.getItem('tags-imaging'));
          this.tagsToSet = JSON.parse(localStorage.getItem('tags-imaging'));
          // check for Tags to set
          if (this.tagsToSet !== undefined && this.tagsToSet !== null) {
            localStorage.setItem('tags-imaging', JSON.stringify(null));
          } else {
            // General tag
            this.tagsToSet = [];
            this.tagsToSet.push(DOCUMENT_TAG.General);
            localStorage.setItem('tags-imaging', JSON.stringify(this.tagsToSet));
          }
        }
      }
    }
    else {
      console.log('2 getAttachedDevices localStorage.getItem(\'tags-imaging\')', localStorage.getItem('tags-imaging'));
      this.tagsToSet = [];
      this.tagsToSet = JSON.parse(localStorage.getItem('tags-imaging'));
      console.log('this.tagsToSet ', this.tagsToSet);
      // check for Tags to set
      if (this.tagsToSet !== undefined && this.tagsToSet !== null) {
        localStorage.setItem('tags-imaging', JSON.stringify(null));
      } else {
        this.tagsToSet = [];
        // General tag
        this.tagsToSet.push(DOCUMENT_TAG.General);
      }
    }
  }
  isServiceBrokerRunning(callback?: () => void) {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.initServiceBroker(false, true);
          // Execute callback if provided
          if (callback) {
            callback();
          }
        } else {
          clearInterval(intervalSubscription);
          // try to check again before displaying the message
          this.isServiceBrokerRunningCheckAgain();
        }
      }, 100);
    });
  }

  isServiceBrokerRunningCheckAgain() {
    console.log('isServiceBrokerRunningCheckAgain');
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.initServiceBroker(false, true);
        } else {
          clearInterval(intervalSubscription);
          let msg = 'TDOS Service Broker is needed to be able to use the sensor configured for this workstation. \n';
          msg += 'Close TDOS, launch Service Broker from Desktop. It is important you logout of TDOS and log back in. \n';
          msg += 'If Service Broker is not installed, please download the TDOS Service Broker by clicking on the link below and install.';

          msg = "<H1>Service Broker is not running!</H1> <br><br>" +
            '<b>Close TDOS and Launch Service Broker from Desktop!</b>';
          this.drawService.scanSetupDlg(msg);
          return;
        }
      }, 100);
    });
  }


  openTwainSelectionDialog(message) {
    const dialogRef = this.dialog.open(SelectSourceDlgComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'dialog',
      data: {
        message
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Confirmed
      }
    }, err => {
      // Error
    });
  }

  newXrayScanner() {
    console.log('TWAIN: newXrayScanner() isAcquiring=', this.isAcquiring, 'isTwainSessionOpen=', this.isTwainSessionOpen);
    if (this.isAcquiring || this.isTwainSessionOpen) {
      console.log('TWAIN: scan blocked — previous acquisition still in progress');
      this.hideTwainSpinnerTick++;
      return;
    }
    this.isAcquiring = true;
    let twainAvailable = true;
    let selectedTwain: string;

    let storedTwainString = localStorage.getItem('IMAGE_ACQUIRE_TWAIN');

    // Check if TWAIN configuration exists and is valid
    if (!storedTwainString ||
        storedTwainString === 'undefined' ||
        storedTwainString === 'null' ||
        storedTwainString.trim() === '') {
      console.log('No Twain configuration found.');
      this.isAcquiring = false;
      this.hideTwainSpinnerTick++;
      this.dialogService.openConfirmDialog('No Twain configuration found.').subscribe((result) => {
        // Optionally open the TWAIN selection dialog
        if (result) {
          this.openTwainSelectionDialog('Select TWAIN Driver');
        }
      });
      return;
    }

    try {
      selectedTwain = JSON.parse(storedTwainString);
    } catch (e) {
      this.isAcquiring = false;
      this.hideTwainSpinnerTick++;
      console.error('TWAIN: invalid stored TWAIN configuration', e);
      return;
    }
    if (this.drawService.isWindowsEnvironment) {
      (this.drawService.scanningService as lt.Scanning.TwainScanning).isAvailable((available) => {
        if (!available) {
          this.isTwainServiceStarted = true;
          twainAvailable = false;
          alert('No TWAIN Data Source installed');
        }
        /*else {
           // Custom User command sample (Calling Load Command to append pages from the specified url)
        }*/
      }, null);
    }
    let src: string;
    let newPageAdded: boolean = false;
    if (twainAvailable) {
      this.deselectImageContainer();
      const id = uuidv4();
      this.docId = 'D' + id;
      this.totalScannedPages = 0;
      this.lastPageNumber = 0;
      console.log('TWAIN: calling start()');
      this.drawService.scanningService.start(null)
        .done(() => {
          this.isTwainSessionOpen = true;
          console.log('TWAIN: start() succeeded, calling selectSource:', selectedTwain);
          this.drawService.scanningService.selectSource(selectedTwain)
            .done(() => {
              console.log('TWAIN: selectSource() succeeded, calling acquire()');
              // acquire() is what actually opens the native TWAIN UI - this is the best
              // available signal that it's about to display, so hide the top-menu spinner now.
              this.hideTwainSpinnerTick++;
              this.drawService.scanningService.acquire()
                .done((status) => {
                  console.log('TWAIN: acquire() succeeded, calling getStatus()');
                  this.drawService.scanningService.getStatus()
                    .done((status) => {
                      console.log('TWAIN: getStatus() pageCount =', status?.pageCount);
                      newPageAdded = this.updatePagesView(status);
                      this.isAcquiring = false;
                      console.log('TWAIN: isAcquiring set to false, isTwainSessionOpen=', this.isTwainSessionOpen);
                      if (newPageAdded) {
                        this.isTwainServiceStarted = true;
                        src = this.drawService.scanningService.getPage(this.totalScannedPages, lt.Scanning.RasterImageFormat.Unknown, 0, 0, 0);
                        console.log('TWAIN: getPage(', this.totalScannedPages, ') src =', src);
                        if (src) {
                          // Fetch the image into browser memory BEFORE calling stop(), because stop()
                          // clears the service broker's GetPage buffer and makes the URL invalid.
                          console.log('TWAIN: fetching image blob before closing session');
                          fetch(src)
                            .then(res => {
                              if (!res.ok) throw new Error('GetPage HTTP ' + res.status);
                              return res.blob();
                            })
                            .then(blob => {
                              const blobUrl = URL.createObjectURL(blob);
                              console.log('TWAIN: image fetched as blob, pushing to list');
                              const tdoImage = new TDOxImage();
                              tdoImage.DocumentId = null;
                              tdoImage.selected = true;
                              tdoImage.URL = blobUrl;
                              tdoImage.ImageID = this.docId;
                              tdoImage.deviceId = this.selectedDevice.DeviceID;
                              tdoImage.ImageName = this.currentPatientName;
                              tdoImage.bImageLoaded = true;
                              tdoImage.Categories = this.tagsToSet || [];
                              tdoImage.documentGroupObjectId = this.fromOrganizer?.objectId;
                              tdoImage.bImageSaved = false;
                              tdoImage.selectedFile = null;
                              tdoImage.blob = '';
                              tdoImage.annotationXmlData = '';
                              tdoImage.PatientID = this.currentPatientID;
                              tdoImage.imageSource = 'Twain';
                              tdoImage.drawTextDefaults = this.drawTextDefaults;
                              tdoImage.drawStampDefaults = this.drawStampDefaults;
                              tdoImage.annotationsDefaults = this.annotationsDefaults;
                              tdoImage.drawToolsDefaults = this.drawToolsDefaults;
                              tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
                              tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
                              tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
                              this.listOpenImages.push(tdoImage);
                              this.selectedIndex = this.listOpenImages.length - 1;
                              this.gammaVal = 100;
                              this.contrastVal = 0;
                              this.brightnessVal = 0;
                              this.changeDetection.detectChanges();
                              // Image is now in browser memory — safe to close the TWAIN session
                              this.closeTwainSession();
                            })
                            .catch(err => {
                              console.error('TWAIN: failed to fetch image from GetPage URL', err);
                              this.closeTwainSession();
                            });
                        } else {
                          console.warn('TWAIN: getPage() returned empty src');
                          this.closeTwainSession();
                        }
                      } else if (status?.isScanning) {
                        // pageCount = 0 but still scanning: image arrives asynchronously via
                        // brokerImageData WebSocket. closeTwainSession() is called there once
                        // the image is delivered.
                        console.log('TWAIN: pageCount = 0, isScanning = true, waiting for brokerImageData to deliver image');
                      } else {
                        // pageCount = 0 and isScanning = false: the user closed/cancelled the
                        // TWAIN UI without acquiring anything. Nothing is coming via the
                        // WebSocket, so close the session now - otherwise isTwainSessionOpen
                        // stays stuck true forever and every future click is silently blocked
                        // by the isAcquiring||isTwainSessionOpen guard at the top of this method.
                        console.log('TWAIN: pageCount = 0, isScanning = false — scan was cancelled, closing session');
                        this.closeTwainSession();
                      }
                    })
                    .fail((err: any) => {
                      this.isAcquiring = false;
                      console.error('TWAIN: getStatus() failed', err);
                      this.closeTwainSession();
                    });
                })
                .fail((err: any) => {
                  this.isAcquiring = false;
                  console.error('TWAIN: acquire() failed', err);
                  this.closeTwainSession();
                });
            })
            .fail((err: any) => {
              this.isAcquiring = false;
              this.hideTwainSpinnerTick++;
              console.error('TWAIN: selectSource() failed', err);
              this.closeTwainSession();
            });
        })
        .fail((err: any) => {
          this.isAcquiring = false;
          this.hideTwainSpinnerTick++;
          console.error('TWAIN: start() failed — is the service broker running?', err);
        });

    }
  }

  private closeTwainSession(): void {
    console.log('TWAIN: closeTwainSession() isTwainSessionOpen=', this.isTwainSessionOpen);
    if (!this.isTwainSessionOpen) return;
    this.isTwainSessionOpen = false;
    console.log('TWAIN: closing session via stop()');
    this.drawService.scanningService.stop();
  }

  private updatePagesView(status: lt.Scanning.ScanningStatus): boolean {
    let newPageAdded: boolean = false;
    for (; this.totalScannedPages < status.pageCount; this.lastPageNumber++) {
      newPageAdded = true;
      this.totalScannedPages++;
    }
    return newPageAdded;
  }

  btnClickAnnotationObj(annObject: string) {
    let annObjId: number;
    switch (annObject) {
      case 'SelectPointer':
        annObjId = lt.Annotations.Engine.AnnTextObject.selectObjectId;
        break;
      case 'Text':
        annObjId = lt.Annotations.Engine.AnnTextObject.textObjectId;
        break;
      case 'Line':
        annObjId = lt.Annotations.Engine.AnnTextObject.lineObjectId;
        break;
      case 'Rectangle': {
        annObjId = lt.Annotations.Engine.AnnTextObject.rectangleObjectId;
        break;
      }
      case 'Ellipse': {
        annObjId = lt.Annotations.Engine.AnnTextObject.ellipseObjectId;
        break;
      }
      case 'Arrow': {
        annObjId = lt.Annotations.Engine.AnnTextObject.pointerObjectId;
        break;
      }
      case 'Redaction': {
        annObjId = lt.Annotations.Engine.AnnTextObject.redactionObjectId;
        break;
      }
      case 'FreeHand': {
        annObjId = lt.Annotations.Engine.AnnTextObject.freehandObjectId;
        break;
      }
      case 'TextPointer': {
        annObjId = lt.Annotations.Engine.AnnTextObject.textPointerObjectId;
        break;
      }
      case 'Stamp': {
        annObjId = lt.Annotations.Engine.AnnTextObject.stampObjectId;
        break;
      }
      case 'Ruler': {
        annObjId = lt.Annotations.Engine.AnnTextObject.rulerObjectId;
        break;
      }
      case 'PolyRuler': {
        annObjId = lt.Annotations.Engine.AnnTextObject.polyRulerObjectId;
        break;
      }
      case 'Hilite': {
        annObjId = lt.Annotations.Engine.AnnTextObject.hiliteObjectId;
        break;
      }
      default: {
        annObjId = lt.Annotations.Engine.AnnTextObject.selectObjectId;
        break;
      }
    }

    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        if (annObject === 'standard-stamp') {
          component.isRotation = false;
          component.onAddStamp();
        }
        else if (annObject === 'stamp') {
          component.isRotation = false;
        }
        else {
          component.isRotation = false;
          component.onAnnotationChange(annObjId);
        }
      }
    });
  }

  btnClickUndo(all) {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        if (all === 0) {
          component.isRotation = false;
          component.undoAnnotation(all);
        } else {
          const result = confirm('<i>Are you sure you want to clear all annotations?</i>', 'Clear All Annotations?');
          result.then((dialogResult) => {
            if (dialogResult === true) {
              component.isRotation = false;
              component.undoAnnotation(all);
            }
          });
        }
      }
    });
  }
  btnClickRevert() {
    // this.imageContainers.forEach(component => {
      // if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        const selectedFile: File = this.listOpenImages[this.selectedIndex].selectedFile;
        const selectedTdoImage: TDOxImage = this.listOpenImages[this.selectedIndex];
        this.listOpenImages = this.listOpenImages.filter(image => image.ImageID !== this.listOpenImages[this.selectedIndex].ImageID);
        switch (selectedTdoImage.imageSource){
          case 'File': {
            this.openFile(selectedFile, true);
            break;
          }
          case 'DesktopAcquire' : {
            this.loadImagesFromDesktopAcquire(selectedTdoImage.desktopAcquireDocId);
            break;
          }
          case 'Organizer' : {
            // console.log('btnClickRevert to loadImagesFromOrganizer this.fromOrganizer ', this.fromOrganizer);
            this.loadImagesFromOrganizer(selectedTdoImage.DocumentId);
            break;
          }
          case 'Twain' : {
            this.reloadImagefromTwain(selectedTdoImage);
            break;
          }
        }
      // }
    // });
  }
  reloadImagefromTwain(selectedTdoImage: TDOxImage) {
     this.imageContainers.forEach(component => {
     if (component.ImageName === selectedTdoImage.ImageID) {
        const id = uuidv4();
        this.docId = 'D' + id;
        const tdoImage = new TDOxImage();
        tdoImage.DocumentId = null;
        tdoImage.selected = true;
        tdoImage.URL = component.imageViewer.imageUrl;
        tdoImage.ImageID = this.docId;
        tdoImage.ImageName = selectedTdoImage.ImageID;
        tdoImage.bImageLoaded = true;
        tdoImage.Categories = [];
        tdoImage.bImageSaved = true;
        tdoImage.selectedFile = null;
        tdoImage.blob = '';
        tdoImage.annotationXmlData = '';
        tdoImage.PatientID = this.currentPatientID;
        tdoImage.imageSource = 'Twain';
        tdoImage.isRevert = true;
        tdoImage.documentGroupObjectId = selectedTdoImage.documentGroupObjectId;
        tdoImage.drawTextDefaults = this.drawTextDefaults;
        tdoImage.drawStampDefaults = this.drawStampDefaults;
        tdoImage.annotationsDefaults = this.annotationsDefaults;
        tdoImage.drawToolsDefaults = this.drawToolsDefaults;
        tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
        tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
        tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
        this.listOpenImages.push(tdoImage);
        this.selectedIndex = this.listOpenImages.length - 1;
        this.gammaVal = 100;
        this.contrastVal = 0;
        this.brightnessVal = 0;
     }
     });

  }
  btnClickFillRegion() {
    this.listOpenImages[this.selectedIndex].bImageSaved = false;
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.onFill();
        // component.onAnnotationChange(-36);
      }
    });
  }

  /***** FILE HANDLING *********************************************************************************************************************
   ****************************************************************************************************************************************/
  getParentDocument(parentDocId) {
    const tags: string [] = [];
    this.fileManagerService.getDocument(parentDocId).subscribe((docRes) => {
      this.fileManagerService.getDocumentTags(parentDocId).subscribe((docTags) => {
        docTags.forEach(tag => {
          tags.push(tag.enumDocumentTagID);
        });

        const tdoImage = new TDOxImage();
        tdoImage.DocumentId = docRes.DocumentID;
        tdoImage.selected = true;
        tdoImage.URL = this.fileManagerService.getDocumentUrlFromDocument(docRes);
        tdoImage.ImageID = docRes.DocumentID;
        tdoImage.ImageName = this.currentPatientName;
        tdoImage.bImageLoaded = false;
        tdoImage.Categories = tags;
        tdoImage.bImageSaved = false;
        tdoImage.selectedFile = null;
        tdoImage.blob = '';
        tdoImage.annotationXmlData = '';
        tdoImage.PatientID = this.currentPatientID;
        tdoImage.drawTextDefaults = this.drawTextDefaults;
        tdoImage.drawStampDefaults = this.drawStampDefaults;
        tdoImage.annotationsDefaults = this.annotationsDefaults;
        tdoImage.drawToolsDefaults = this.drawToolsDefaults;
        tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
        tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
        tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
        this.listOpenImages.push(tdoImage);
      });
    });
  }

  loadImagesFromFolderMonitor(imgData: string) {
    // get the tooth number associated to the document
    const selectedTeeth: string[] = [];
    const tdoImage = new TDOxImage();
    // tdoImage.DocumentId = docRes.DocumentID;
    tdoImage.selected = true;
    tdoImage.URL = imgData;
    // tdoImage.ImageID = docRes.DocumentID;
    tdoImage.ImageName = this.currentPatientName;
    tdoImage.bImageLoaded = true;
    // tdoImage.Categories = tags;
    tdoImage.bImageSaved = true;
    tdoImage.selectedFile = null;
    tdoImage.blob = '';
    tdoImage.annotationXmlData = '';
    tdoImage.PatientID = this.currentPatientID;
    // tdoImage.selectedTeeth = selectedTeeth;
    tdoImage.AutoSave = false;
    // tdoImage.loadedDocument = docRes;
    // tdoImage.desktopAcquireDocId = docId;
    tdoImage.imageSource = 'FolderMonitor';
    tdoImage.drawTextDefaults = this.drawTextDefaults;
    tdoImage.drawStampDefaults = this.drawStampDefaults;
    tdoImage.annotationsDefaults = this.annotationsDefaults;
    tdoImage.drawToolsDefaults = this.drawToolsDefaults;
    tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
    tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
    tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
    this.listOpenImages.push(tdoImage);

    this.selectedIndex = this.listOpenImages.length - 1;
    this.gammaVal = 100;
    this.contrastVal = 0;
    this.brightnessVal = 0;

  }
  openFileFromServiceBroker(uploadedFile: string, docId: string, thumbnailDocId, tags: string[], toothList: string[]) {
    // const tags: string[] = [];
    this.fileManagerService.getDocument(docId).subscribe((docRes) => {
      tdoImage.loadedDocument = docRes;
    });
      // get the tooth number associated to the document
    const selectedTeeth: CaseTooth[] = [];

    // console.log('mtm this.toothDetail ', this.toothDetail);
    if (this.toothDetail) {
      if (toothList.length === 0){
        for (const item of this.toothDetail) {
          selectedTeeth.push(item);
        }
      }
      else {
        if (toothList[0] !== Constants.emptyGuid) {
          for (const item of toothList) {
            const tooth = this.toothDetail.find(p => p.CaseWorkItemToothId === item);
            selectedTeeth.push(tooth);
          }
        }
      }
    }

    this.deselectImageContainer();
    const tdoImage = new TDOxImage();
    tdoImage.DocumentId = docId;
    tdoImage.ParentDocumentId = docId;
    tdoImage.thumbDocId = thumbnailDocId;
    tdoImage.selected = true;
    tdoImage.URL = uploadedFile;
    tdoImage.ImageID = docId;
    tdoImage.ImageName = this.currentPatientName;
    tdoImage.bImageLoaded = false;
    tdoImage.Categories = tags;
    tdoImage.documentGroupObjectId = this.fromOrganizer?.objectId;
    tdoImage.bImageSaved = true;
    tdoImage.selectedFile = null;
    tdoImage.blob = '';
    tdoImage.annotationXmlData = '';
    tdoImage.PatientID = this.currentPatientID;
    tdoImage.selectedTeeth = selectedTeeth;
    tdoImage.AutoSave = false;
    // tdoImage.loadedDocument = docRes;
    tdoImage.desktopAcquireDocId = docId;
    if (this.selectedDevice === undefined) {
      tdoImage.deviceId = null;
    }
    else {
      if (this.selectedDevice.DeviceID) {
        tdoImage.deviceId = this.selectedDevice.enumDeviceSBID;
      }
    }
    tdoImage.imageSource = 'FolderMonitor';
    tdoImage.drawTextDefaults = this.drawTextDefaults;
    tdoImage.drawStampDefaults = this.drawStampDefaults;
    tdoImage.annotationsDefaults = this.annotationsDefaults;
    tdoImage.drawToolsDefaults = this.drawToolsDefaults;
    tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
    tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
    tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
    this.listOpenImages.push(tdoImage);
    this.changeDetection.detectChanges();
    this.selectedIndex = this.listOpenImages.length - 1;
    this.gammaVal = 100;
    this.contrastVal = 0;
    this.brightnessVal = 0;

    // Desktop Acquire (Service Broker) already saved this document server-side before sending it here -
    // Studio's own Save is never called for it, so the recall/DocumentGroup link has to be created now.
    if (tdoImage.documentGroupObjectId) {
      const groupModel = new DocumentGroupCreationModel();
      groupModel.ObjectId = tdoImage.documentGroupObjectId;
      groupModel.PatientId = this.currentPatientID;
      groupModel.documentIds = [docId];
      this.fileManagerService.createDocumentGroup(groupModel).subscribe(() => {
        this.notifyLandingWindowDocumentGroupRefresh();
      });
    }

  }

  /**
   * Studio is `window.open`'d separately from Landing, so a document-group refresh needs the same
   * cross-window nudge already used for pre/post-op: a same-origin localStorage write fires `storage`
   * in the Landing window (see tdo-document-viewer.component.ts onStudioSaveStorage).
   */
  private notifyLandingWindowDocumentGroupRefresh(): void {
    try {
      localStorage.setItem(
        MessagingConstants.LOCAL_STORAGE_PREPOST_LANDING_REFRESH,
        JSON.stringify({ patientId: this.globals.currentPatientId, t: Date.now() })
      );
    } catch {
      // private mode / quota
    }
  }

  loadImagesFromDesktopAcquire(docId: string) {
    const tags: string[] = [];
    const parentDocIds: string[] = [];
    this.fileManagerService.getDocument(docId).subscribe((docRes) => {
      parentDocIds.push(docId);
      this.fileManagerService.getThumbnailsByParentDocumentIds(parentDocIds).subscribe((thumbDocRes) => {
        this.fileManagerService.getDocumentTags(docId).subscribe((docTags) => {
        // console.log('docTags ' + docTags[0]);
        docTags.forEach(tag => {
          tags.push(tag.enumDocumentTagID);
        });

        // get the tooth number associated to the document
        const selectedTeeth: string[] = [];
        const tdoImage = new TDOxImage();
        tdoImage.DocumentId = docRes.DocumentID;
        tdoImage.ParentDocumentId = docRes.DocumentID;
        tdoImage.thumbDocId = thumbDocRes[0].DocumentID;
        tdoImage.selected = true;
        tdoImage.URL = this.fileManagerService.getDocumentUrlFromDocument(docRes);
        tdoImage.ImageID = docRes.DocumentID;
        tdoImage.ImageName = this.currentPatientName;
        tdoImage.bImageLoaded = true;
        tdoImage.Categories = tags;
        tdoImage.bImageSaved = true;
        tdoImage.selectedFile = null;
        tdoImage.blob = '';
        tdoImage.annotationXmlData = '';
        tdoImage.PatientID = this.currentPatientID;
        // tdoImage.selectedTeeth = selectedTeeth;
        tdoImage.AutoSave = false;
        tdoImage.loadedDocument = docRes;
        tdoImage.desktopAcquireDocId = docId;
        tdoImage.deviceId = this.selectedDevice.DeviceID;
        tdoImage.imageSource = 'DesktopAcquire';
        tdoImage.drawTextDefaults = this.drawTextDefaults;
        tdoImage.drawStampDefaults = this.drawStampDefaults;
        tdoImage.annotationsDefaults = this.annotationsDefaults;
        tdoImage.drawToolsDefaults = this.drawToolsDefaults;
        tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
        tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
        tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
        this.listOpenImages.push(tdoImage);

        this.selectedIndex = this.listOpenImages.length - 1;
        this.gammaVal = 100;
        this.contrastVal = 0;
        this.brightnessVal = 0;

      });
        // console.log(new Date().toString() + ' - tdoImage url: ' + this.fileManagerService.getDocumentUrlFromDocument(docRes) + 'Datetime: ' );
      });
    });

  }

  loadImagesFromOrganizer(DocumentId: string = '') {
    //const emptyGuid = '00000000-0000-0000-0000-000000000000';
    // console.log('loadImagesFromOrganizer DocumentId ', DocumentId);
    const enumDocumentFileTypeJPG = '0000001B-1000-0000-0000-000000000003';
    const enumDocumentFileTypePNG = '0000001B-1000-0000-0000-000000000015';
    if (this.fromOrganizer) {
      this.documents = this.fromOrganizer.documents;
      const parentDocIds = this.documents.map(p => p.ParentDocumentID);
      this.fileManagerService.getDocuments(parentDocIds).subscribe((res) => {
        const imagesOnly: DocumentDataModel[] = res.filter(p => p.enumDocumentFileTypeID === enumDocumentFileTypeJPG.toLowerCase() ||
          p.enumDocumentFileTypeID === enumDocumentFileTypePNG.toLowerCase());
        for (const mod of imagesOnly) {
          if (DocumentId === '' || DocumentId === mod.DocumentID) {
          const tdoImage = new TDOxImage();
          const thumbDocData = this.documents.filter(p => p.ParentDocumentID === mod.DocumentID)[0]; // need the thumbnail Doc Ids for Saving
          let thumbDocId: string;
          thumbDocId = thumbDocData?.DocumentID;
          if (mod.hasAnnotation) {
            let parentDocIdAnn: string[] = [];
            if (mod.ParentDocumentID && mod.ParentDocumentID !== Constants.emptyGuid) {
              parentDocIdAnn = [mod.ParentDocumentID];
            }
            else {
              parentDocIdAnn = [mod.DocumentID];
            }
            this.fileManagerService.getDocuments(parentDocIdAnn).subscribe((resAnn) => {
              // this.fileManagerService.getDocument(mod.ParentDocumentID).subscribe((docRes) => {
              for (const modAnn of resAnn) {
                if (modAnn.DocumentID !== Constants.emptyGuid) {
                  const isCreateBlankImage = JSON.parse(localStorage.getItem('open-blank-image'));
                  if (isCreateBlankImage === 'true') {
                    localStorage.removeItem('open-blank-image');
                    this.createBlankCanvas( 'WhiteCanvas', false, mod.dataDocumentTags.map(p => p.enumDocumentTagID));
                  }
                  this.fileManagerService.getDocumentAnnotation(mod.PhysicalFileName, this.currentPatientID).subscribe((resAnnFile) => {
                    tdoImage.annotationXmlData = this.fileManagerService.getDocumentUrlFromDocument(resAnnFile);
                    tdoImage.DocumentId = modAnn.DocumentID;
                    tdoImage.ParentDocumentId = mod.ParentDocumentID;
                    tdoImage.ImageID = modAnn.DocumentID;
                    tdoImage.URL = this.fileManagerService.getDocumentUrlFromDocument(modAnn);
                    tdoImage.loadedDocument = modAnn;
                    tdoImage.createDate = modAnn.DocumentCreateDate;
                    tdoImage.Categories = modAnn.dataDocumentTags?.map(p => p.enumDocumentTagID) ?? [];
                    if (this.fromOrganizer.tags?.length) {
                      tdoImage.Categories = [...new Set([...tdoImage.Categories, ...this.fromOrganizer.tags])];
                      if (!modAnn.dataDocumentTags) { modAnn.dataDocumentTags = []; }
                      for (const tagId of this.fromOrganizer.tags) {
                        if (!modAnn.dataDocumentTags.some(t => t.enumDocumentTagID?.toLowerCase() === tagId.toLowerCase())) {
                          const docTag = new DocumentTagDataModel();
                          docTag.enumDocumentTagID = tagId;
                          docTag.DocumentID = modAnn.DocumentID;
                          docTag.enumDocumentTag = this.documentTagList?.find(t => t.ValidValueItemId?.toLowerCase() === tagId.toLowerCase());
                          modAnn.dataDocumentTags.push(docTag);
                        }
                      }
                    }
                    tdoImage.deviceId = modAnn.DeviceID;
                    tdoImage.bImageSaved = true;
                    tdoImage.folderId = this.fromOrganizer.folderId;
                    tdoImage.documentGroupObjectId = this.fromOrganizer.objectId;
                    tdoImage.thumbDocId = thumbDocId;
                    tdoImage.imageSource = 'Organizer';
                    tdoImage.drawTextDefaults = this.drawTextDefaults;
                    tdoImage.drawStampDefaults = this.drawStampDefaults;
                    tdoImage.annotationsDefaults = this.annotationsDefaults;
                    tdoImage.drawToolsDefaults = this.drawToolsDefaults;
                    tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
                    tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
                    tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
                    tdoImage.drawCanvasDefaults = this.drawCanvasDefaults;
                    this.ngZone.run(() => {
                      this.listOpenImages.push(tdoImage);
                      this.selectedIndex = this.listOpenImages.length - 1;
                      localStorage.removeItem('open-in-imaging');
                      this.changeDetection.detectChanges();
                    });
                  });
                }
              }
            });
          } else {
            const isCreateBlankImage = JSON.parse(localStorage.getItem('open-blank-image'));
            if (isCreateBlankImage === 'true') {
              localStorage.removeItem('open-blank-image');
              this.createBlankCanvas( 'WhiteCanvas', false, mod.dataDocumentTags.map(p => p.enumDocumentTagID));
            }
            tdoImage.DocumentId = mod.DocumentID;
            // the DocumentID will be the ParentDocumentId when saving again
            tdoImage.ParentDocumentId = mod.DocumentID;
            tdoImage.ImageID = mod.DocumentID;
            tdoImage.URL = this.fileManagerService.getDocumentUrlFromDocument(mod);
            tdoImage.loadedDocument = mod;
            tdoImage.createDate = mod.DocumentCreateDate;
            tdoImage.Categories = mod.dataDocumentTags?.map(p => p.enumDocumentTagID) ?? [];
            if (this.fromOrganizer.tags?.length) {
              tdoImage.Categories = [...new Set([...tdoImage.Categories, ...this.fromOrganizer.tags])];
              if (!mod.dataDocumentTags) { mod.dataDocumentTags = []; }
              for (const tagId of this.fromOrganizer.tags) {
                if (!mod.dataDocumentTags.some(t => t.enumDocumentTagID?.toLowerCase() === tagId.toLowerCase())) {
                  const docTag = new DocumentTagDataModel();
                  docTag.enumDocumentTagID = tagId;
                  docTag.DocumentID = mod.DocumentID;
                  docTag.enumDocumentTag = this.documentTagList?.find(t => t.ValidValueItemId?.toLowerCase() === tagId.toLowerCase());
                  mod.dataDocumentTags.push(docTag);
                }
              }
            }
            tdoImage.deviceId = mod.DeviceID;
            tdoImage.bImageSaved = true;
            tdoImage.folderId = this.fromOrganizer.folderId;
            tdoImage.documentGroupObjectId = this.fromOrganizer.objectId;
            tdoImage.thumbDocId = thumbDocId;
            tdoImage.imageSource = 'Organizer';
            tdoImage.drawTextDefaults = this.drawTextDefaults;
            tdoImage.drawStampDefaults = this.drawStampDefaults;
            tdoImage.annotationsDefaults = this.annotationsDefaults;
            tdoImage.drawToolsDefaults = this.drawToolsDefaults;
            tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
            tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
            tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
            this.ngZone.run(() => {
              this.listOpenImages.push(tdoImage);
              this.selectedIndex = this.listOpenImages.length - 1;
              localStorage.removeItem('open-in-imaging');
              this.changeDetection.detectChanges();
            });
          }
        }
        }
      });
    }
  }

  openFileFromFolderMonitorKEEP(uploadedFile: string, docId: string) {
    // const tags = JSON.parse(tagsJson);
    if (uploadedFile) {
      this.deselectImageContainer();
      const len = this.listOpenImages.length;
      // const id = uuidv4();
      // this.docId = 'D' + id;
      // this.docId = docId;
      const tdoImage = new TDOxImage();
      tdoImage.DocumentId = docId;
      tdoImage.ParentDocumentId = null;
      tdoImage.selected = true;
      tdoImage.URL = uploadedFile;
      tdoImage.ImageID = docId;
      tdoImage.ImageName = this.currentPatientName;
      tdoImage.bImageLoaded = false;
      // tdoImage.folderId = this.fromOrganizer?.folderId;
      // tdoImage.Categories = tags;
      tdoImage.bImageSaved = true;
      // tdoImage.selectedFile = selectedFile;
      tdoImage.blob = '';
      tdoImage.annotationXmlData = '';
      tdoImage.PatientID = this.currentPatientID;
      tdoImage.imageSource = 'FolderMonitor';
      tdoImage.brightnessVal = 0;
      tdoImage.contrastVal = 0;
      tdoImage.gammaVal = 100;
      tdoImage.drawTextDefaults = this.drawTextDefaults;
      tdoImage.drawStampDefaults = this.drawStampDefaults;
      tdoImage.annotationsDefaults = this.annotationsDefaults;
      tdoImage.drawToolsDefaults = this.drawToolsDefaults;
      tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
      tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
      tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
      this.listOpenImages.push(tdoImage);
      this.gammaVal = 100;
      this.contrastVal = 0;
      this.brightnessVal = 0;
    }
  }

  openFile(selectedFile: File, isImageSaved: boolean = false) {
    console.log('openFile selectedFile ', selectedFile);
    if (selectedFile) {
      this.deselectImageContainer();
      const len = this.listOpenImages.length;
      const id = uuidv4();
      this.docId = 'D' + id;
      const tdoImage = new TDOxImage();
      tdoImage.DocumentId = null;
      tdoImage.selected = true;
      tdoImage.URL = null;
      tdoImage.ImageID = this.docId;
      tdoImage.ImageName = this.currentPatientName;
      tdoImage.bImageLoaded = false;
      tdoImage.folderId = this.fromOrganizer?.folderId;
      tdoImage.documentGroupObjectId = this.fromOrganizer?.objectId;
      if (this.selectedCategories && this.selectedCategories.length > 0) {
        let categories = this.selectedCategories.map(p => p.ValidValueItemId);
        if (this.fromOrganizer?.tags?.length) {
          const organizerTagIds = this.fromOrganizer.tags.map(t => t.toLowerCase());
          categories = categories.filter(id => !organizerTagIds.includes(id.toLowerCase()));
        }
        tdoImage.Categories = categories;
      } else {
        tdoImage.Categories = [];
      }
      // tdoImage.bImageSaved = false;
      tdoImage.bImageSaved = isImageSaved;
      tdoImage.selectedFile = selectedFile;
      tdoImage.blob = '';
      tdoImage.annotationXmlData = '';
      tdoImage.PatientID = this.currentPatientID;
      if (selectedFile) {
        tdoImage.imageSource = 'File';
        console.log('tags to set ', this.tagsToSet);
        if (this.tagsToSet != null) {
          let tags = this.tagsToSet;
          if (this.fromOrganizer?.tags?.length) {
            const organizerTagIds = this.fromOrganizer.tags.map(t => t.toLowerCase());
            tags = tags.filter(id => !organizerTagIds.includes(id.toLowerCase()));
          }
          tdoImage.Categories = tags;
        }
      }
      else {
        tdoImage.imageSource = 'BlankCanvas';
      }
      tdoImage.selected = true;
      tdoImage.brightnessVal = 0;
      tdoImage.contrastVal = 0;
      tdoImage.gammaVal = 100;
      tdoImage.drawTextDefaults = this.drawTextDefaults;
      tdoImage.drawStampDefaults = this.drawStampDefaults;
      tdoImage.annotationsDefaults = this.annotationsDefaults;
      tdoImage.drawToolsDefaults = this.drawToolsDefaults;
      tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
      tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
      tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
      tdoImage.drawCanvasDefaults = this.drawCanvasDefaults;
      this.listOpenImages.push(tdoImage);
      this.gammaVal = 100;
      this.contrastVal = 0;
      this.brightnessVal = 0;
    }
  }


  createBlankCanvas(canvasColor: string, isImageSaved: boolean = false, tags: string [] = []) {
      this.deselectImageContainer();
      const len = this.listOpenImages.length;
      const id = uuidv4();
      this.docId = 'D' + id;
      const tdoImage = new TDOxImage();
      tdoImage.DocumentId = null;
      tdoImage.selected = true;
      tdoImage.URL = null;
      tdoImage.ImageID = this.docId;
      tdoImage.ImageName = this.currentPatientName;
      tdoImage.bImageLoaded = false;
      tdoImage.folderId = this.fromOrganizer?.folderId;
      tdoImage.documentGroupObjectId = this.fromOrganizer?.objectId;
      if (tags.length > 0) {
        tdoImage.Categories = tags;
      }
      else {
        if (this.selectedCategories && this.selectedCategories.length > 0) {
          tdoImage.Categories = this.selectedCategories.map(p => p.ValidValueItemId);
        } else {
          tdoImage.Categories = [];
        }
      }
      // tdoImage.bImageSaved = false;
      tdoImage.bImageSaved = isImageSaved;
      tdoImage.selectedFile = null;
      tdoImage.blob = '';
      tdoImage.annotationXmlData = '';
      tdoImage.PatientID = this.currentPatientID;
      tdoImage.imageSource = canvasColor;
      tdoImage.selected = true;
      tdoImage.brightnessVal = 0;
      tdoImage.contrastVal = 0;
      tdoImage.gammaVal = 100;
      tdoImage.drawTextDefaults = this.drawTextDefaults;
      tdoImage.drawStampDefaults = this.drawStampDefaults;
      tdoImage.annotationsDefaults = this.annotationsDefaults;
      tdoImage.drawToolsDefaults = this.drawToolsDefaults;
      tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
      tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
      tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
      tdoImage.drawCanvasDefaults = this.drawCanvasDefaults;
      tdoImage.AutoSave = false;
      this.listOpenImages.push(tdoImage);
      this.gammaVal = 100;
      this.contrastVal = 0;
      this.brightnessVal = 0;
      this.selectedIndex = this.listOpenImages.length - 1;
  }
  onLTSave(bClose, bSaveLocal, bDisplayMsgBox, callback) {
    console.log('onLTSave this.listOpenImages[this.selectedIndex] ', this.listOpenImages[this.selectedIndex]);
    // need to get the image as blob
    // Review this.globals.currentPatientSelectedCaseItem.Case.Description later
    this.bDisplayMsgBox = bDisplayMsgBox;
    this.parentDocId = null;
    this.currentPatientID = this.globals.currentPatientId;
    if (this.listOpenImages[this.selectedIndex].loadedDocument === undefined || this.listOpenImages[this.selectedIndex].loadedDocument === null ) {
      this.listOpenImages[this.selectedIndex].loadedDocument = new DocumentDataModel();
      this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags = [];
      this.listOpenImages[this.selectedIndex].loadedDocument.DocumentID = this.listOpenImages[this.selectedIndex].DocumentId;
      for (const tag of this.listOpenImages[this.selectedIndex].Categories) {
        const cat = this.documentTagList.find(p => p.ValidValueItemId === tag);
        const docTag = new DocumentTagDataModel();
        docTag.enumDocumentTag = cat;
        docTag.enumDocumentTagID = tag;
        docTag.DocumentID = this.listOpenImages[this.selectedIndex].DocumentId;
        this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags.push(docTag);
      }
    }
    if (this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags !== undefined) {
      // array does not exist, is not an array, or is empty
      // ⇒ do not attempt to process array

      for (let i = 0; i < this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags.length; i++) {
        this.documentTags.push(this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags[i]);
      }
      this.listOpenImages[this.selectedIndex].Categories = [];
      for (let i = 0; i < this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags.length; i++) {
        const docTag = this.listOpenImages[this.selectedIndex].loadedDocument.dataDocumentTags[i];
        const tagId = docTag.enumDocumentTag?.ValidValueItemId ?? docTag.enumDocumentTagID;
        if (tagId) {
          this.listOpenImages[this.selectedIndex].Categories.push(tagId);
        }
      }
    }


    /*if (this.listOpenImages[this.selectedIndex].Categories !== undefined) {
      // array does not exist, is not an array, or is empty
      // ⇒ do not attempt to process array

      for (let i = 0; i < this.listOpenImages[this.selectedIndex].Categories.length; i++) {
        this.documentTags.push(this.listOpenImages[this.selectedIndex].Categories[i]);
      }
    }*/
    this.imageContainers.forEach(component => {
      if (component.ImageName === this.listOpenImages[this.selectedIndex].ImageID) {
        component.isSaveAsNew = this.isSaveAsNew;
        component.burnAnnotations();
        component.getImageViewerBlob(true, true, bSaveLocal, () => {
          if (bClose) {
            this.isDisplayClosingMsgBox = false;
            this.onImageContainerClose();
          }
        }); // here
      }// end if
    });

    setTimeout(() => {
      callback();
    }, 200);
  }

  onSaveLibLec(folderIds: string[]) {
    const ids: string[] = [];
    ids.push(this.listOpenImages[this.selectedIndex].DocumentId);
    const addModel = new DocumentsPerFolderModel();
    addModel.documentIds = ids;
    // addModel.documentIds.push(this.listOpenImages[this.selectedIndex].DocumentId);
    addModel.folderIds = folderIds;
    this.fileManagerService.addDocumentsToFolder(addModel).subscribe((res) => {
    });
  }
  onSaveAll() {
    const len = this.listOpenImages.length;
    for (let i = 0; i < len; i++) {
      this.selectedIndex = i;
      this.onLTSave(true, false, false, () => {
        const intervalSubscription = setInterval(_ => {
          if (this.listOpenImages[this.selectedIndex].bImageSaved) {
            clearInterval(intervalSubscription);
            if (this.listOpenImages[this.selectedIndex].imageSource.includes('Canvas')) {
              // set flag that image has been saved the first time
              this.selectedContainer.xImage.AutoSave = true;
            }
            this.selectedIndex++;
          }
        }, 100);
      });
    }
  }
  stopAllFolderMonitors() {
    this.callServiceBroker('stop-folder-monitor',  () => {
      const intervalSubscription = setInterval(_ => {
        if (true) {
          clearInterval(intervalSubscription);
          this.isFolderMonitorRunning();
        }
      },  100);
    }, '', 'all');
  }
  onCloseAll() {
    const len = this.listOpenImages.length;
    this.isSaveAsNew = true;
    for (let i = 0; i < len; i++) {
      this.selectedIndex = i;
      if (this.listOpenImages[this.selectedIndex].bImageSaved === false) {
        this.onLTSave(false, false, false, () => {
          const intervalSubscription = setInterval(_ => {
            if (this.listOpenImages[this.selectedIndex].bImageSaved) {
              clearInterval(intervalSubscription);
              this.listOpenImages = this.listOpenImages.filter(image => image.ImageID !== this.listOpenImages[this.selectedIndex].ImageID);
            }
          }, 100);
        });
      } else {
        this.listOpenImages = this.listOpenImages.filter(image => image.ImageID !== this.listOpenImages[this.selectedIndex].ImageID);
      }
    }
  }
  /***** IMAGE CONTAINER HANDLING **********************************************************************************************************
   ****************************************************************************************************************************************/
  onImageClose(event: string) {
    if (this.selectedIndex === this.listOpenImages.length) {
      this.selectedIndex = this.listOpenImages.length - 1;
    }

    if (!this.listOpenImages[this.selectedIndex].bImageSaved) {
      this.dialogService.openConfirmDialog('The image has not been saved. Are you sure you want to close?').subscribe((result) => {
        if (result === true) {
          // close without saving
          const file = this.listOpenImages.findIndex(p => p.ImageID === event);
          if (file > -1) {
            this.listOpenImages.splice(file, 1);
          }
          this.selectedIndex = 0;
        }
      });
    } else {
      const file = this.listOpenImages.findIndex(p => p.ImageID === event);
      if (file > -1) {
        this.listOpenImages.splice(file, 1);
      }

      this.selectedIndex = 0;
    }
  }

  onImageContainerClose() {
    if (this.listOpenImages[this.selectedIndex].bImageSaved === false && this.isDisplayClosingMsgBox) {
      this.isDisplayClosingMsgBox = true;
      this.dialogService.openConfirmDialog('The image has not been saved. Are you sure you want to close?').subscribe((result) => {
        if (result === true) {
          this.listOpenImages = this.listOpenImages.filter(image => image.ImageID !== this.listOpenImages[this.selectedIndex].ImageID);
        }
      });
    } else {
      this.listOpenImages = this.listOpenImages.filter(image => image.ImageID !== this.listOpenImages[this.selectedIndex].ImageID);
    }
    this.selectedIndex = 0;
  }

  onImageContainerClicked(file: TDOxImage, container: TdoImagingImageContainerComponent) {
    this.selectedContainer = container;
    this.lastFileClicked = file;
    let idx = 0;
    for (const a of this.listOpenImages) {
      if (this.listOpenImages[idx].ImageID === file.ImageID) {
        this.listOpenImages[idx].selected = true;
        this.selectedIndex = idx;
        // gamma value for slider
        this.gammaVal = this.listOpenImages[this.selectedIndex].gammaVal;
        this.contrastVal = this.listOpenImages[this.selectedIndex].contrastVal;
        this.brightnessVal = this.listOpenImages[this.selectedIndex].brightnessVal;
      } else {
        this.listOpenImages[idx].selected = false;
      }
      idx++;
    }
  }

  deselectImageContainer() {
    let idx = 0;
    for (const a of this.listOpenImages) {
      this.listOpenImages[idx].selected = false;
      idx++;
    }
  }

  onImageSaved(event: TdoImagingImageContainerComponent) {
    console.log('onImageSaved event ', event);
    this.listOpenImages[this.listOpenImages.length - 1].DocumentId = event.document.DocumentID;
    this.listOpenImages[this.listOpenImages.length - 1].URL = event.imageViewer.imageUrl;
    this.listOpenImages[this.listOpenImages.length - 1].bImageSaved = true;
    this.selectedIndex = this.listOpenImages.length - 1;
  }

  onContainerOriginalImageLoaded(event: HTMLImageElement, mdiItem: TdoMdiItemComponent) {
    this.ngZone.run(() => {
      const bounds = new TdoMdiBoundsModel();
      bounds.left = 0;
      bounds.top = 0;
      bounds.width = event.width;
      bounds.height = event.height + 80;
      mdiItem.setOriginalBounds(bounds, TdoMdiBoundsModel.HARD_RESET_TYPE);
      setTimeout(() => {
        if (this.imageContainers.length > 0) {
          this.selectedContainer = this.imageContainers.first;
          this.gammaVal = this.listOpenImages[this.selectedIndex].gammaVal;
          this.contrastVal = this.listOpenImages[this.selectedIndex].contrastVal;
          this.brightnessVal = this.listOpenImages[this.selectedIndex].brightnessVal;
        }
        if (this.imageContainers.length === 1) {
          mdiItem.toggleMaximize();
        } else if (this.imageContainers.length === 2) {
          this.mdiManager.setItemsEqual();
        } else if (this.imageContainers.length > 2) {
          const storedLayout = localStorage.getItem('imaging-layout');
          if (!storedLayout || storedLayout === 'cascade') {
            if (!storedLayout) {
              this.mdiManager.setTile();
            } else {
              this.mdiManager.setCascade();
            }
          } else if (storedLayout === 'tile') {
            this.mdiManager.setTile();
          } else {

          }
        }
      }, 200);

      if (this.imagesToLoad) {
        this.openFile(this.imagesToLoad.shift());
      }
    });
  }

  onToothSelectorUpdate() {
    this.drawService.getCaseTooth(this.globals.currentPatientCaseId, this.currentPatientCaseWorkItemID,
      this.globals.currentToothNumberingId).subscribe((caseToothModelResponse) => {

      if (caseToothModelResponse) {
        console.log('caseToothModelResponse ', caseToothModelResponse);
        this.toothDetail = caseToothModelResponse;
        this.ngZone.run(() => this.isReady = true);
        if (Object.keys(caseToothModelResponse).length === 0) {
          console.log('No tooth');
        }
      }
    });
  }

  onMDIManagerDblClicked() {
    if (!this.isImageDoubleClick) {
      this.openOrganizer();
    }
    this.isImageDoubleClick = false;
  }
  openOrganizer() {
    const config = new MatDialogConfig();
    // config.panelClass = 'standard-dialog';

    config.height = '800px';
    config.width = '1300px';
    config.data = {
      PickList: 'true',
    };
    this.dialog.open(TdoOrganizerComponent, config).afterClosed().subscribe((result) => {
      if (result) {
        // return
      }
      // The organizer writes to localStorage before closing; read it here directly instead of
      // waiting for the SignalR REFRESH_IMAGING round-trip, which became unreliable after Angular 21.
      const pending = JSON.parse(localStorage.getItem('open-in-imaging'));
      if (pending?.documents) {
        localStorage.removeItem('open-in-imaging');
        this.fromOrganizer = pending;
        this.loadImagesFromOrganizer();
      }
    });
  }

  onImageDoubleClick(isImageDoubleClick: boolean) {
    this.isImageDoubleClick = isImageDoubleClick;
  }
  onContinuousXray(isOk: boolean) {
    // The continuous-xray toggle (TX-5481) was never actually wired up in the UI
    // (see the commented-out checkbox in imaging-top-menu.component.html), so this
    // fired unconditionally for every Twain capture and re-triggered newXrayScanner()
    // forever, one capture after another with no way to stop. Disabled until a real
    // toggle exists to gate on.
  }

  // Context Menu Methods
  onMainContextMenu(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    // Remove any existing context menu
    this.removeContextMenu();

    // Create and show context menu
    this.showContextMenu(event.clientX, event.clientY);
  }

  private showContextMenu(x: number, y: number) {
    // Create context menu element using the same styling as organizer
    const contextMenu = document.createElement('div');
    contextMenu.className = 'image-context-menu';
    contextMenu.style.cssText = `
      position: fixed;
      width: 200px;
      background-color: var(--tdo-primary-accent);
      border-radius: var(--border-radius);
      color: white;
      padding: 6px;
      z-index: 10000;
    `;
    contextMenu.setAttribute('data-cy', 'tdo-imaging-context-menu');

    // Create paste item
    const pasteItem = document.createElement('div');
    pasteItem.textContent = 'Paste';
    pasteItem.className = 'item';
    pasteItem.style.cssText = `
      user-select: none;
      cursor: pointer;
      padding: 6px;
      border-radius: var(--border-radius);
    `;
    pasteItem.setAttribute('data-cy', 'tdo-imaging-context-menu-paste');

    // Add hover effects matching organizer style
    pasteItem.addEventListener('mouseenter', () => {
      pasteItem.style.backgroundColor = 'var(--tdo-primary)';
      pasteItem.style.color = 'white';
    });
    pasteItem.addEventListener('mouseleave', () => {
      pasteItem.style.backgroundColor = 'transparent';
      pasteItem.style.color = 'white';
    });

    // Add click handler
    pasteItem.addEventListener('click', () => {
      this.onContextMenuPaste();
      this.removeContextMenu();
    });

    contextMenu.appendChild(pasteItem);
    document.body.appendChild(contextMenu);

    // Position the menu
    const rect = contextMenu.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Adjust position if menu would go off screen
    let finalX = x;
    let finalY = y;

    if (x + rect.width > viewportWidth) {
      finalX = x - rect.width;
    }
    if (y + rect.height > viewportHeight) {
      finalY = y - rect.height;
    }

    contextMenu.style.left = finalX + 'px';
    contextMenu.style.top = finalY + 'px';

    // Store reference for cleanup
    (this as any).currentContextMenu = contextMenu;

    // Add click listener to close menu when clicking elsewhere
    setTimeout(() => {
      document.addEventListener('click', this.removeContextMenu.bind(this));
    }, 0);
  }

  private removeContextMenu() {
    const contextMenu = (this as any).currentContextMenu;
    if (contextMenu && contextMenu.parentNode) {
      contextMenu.parentNode.removeChild(contextMenu);
      (this as any).currentContextMenu = null;
    }
    document.removeEventListener('click', this.removeContextMenu.bind(this));
  }

  async onContextMenuPaste() {
    console.log('Context menu paste clicked');
    this.removeContextMenu();

    try {
      // Check if Clipboard API is available
      if (!navigator.clipboard) {
        console.warn('Clipboard API not available');
        this.snackbar.open('Clipboard API not supported in this browser', '', {
          duration: 3000,
          verticalPosition: 'top'
        });
        return;
      }

      // Read clipboard contents
      const clipboardItems = await navigator.clipboard.read();

      // Look for image data in clipboard
      for (const clipboardItem of clipboardItems) {
        for (const type of clipboardItem.types) {
          if (type.startsWith('image/')) {

            // Get the image blob
            const blob = await clipboardItem.getType(type);

            // Convert blob to data URL
            const reader = new FileReader();
            reader.onload = () => {
              const dataUrl = reader.result as string;
              this.loadPastedImage(dataUrl);
            };
            reader.readAsDataURL(blob);
            return;
          }
        }
      }

      // Check for text content that might be a file path
      for (const clipboardItem of clipboardItems) {
        for (const type of clipboardItem.types) {
          if (type === 'text/plain') {
            const text = await clipboardItem.getType(type);
            const textContent = await text.text();

            // Check if the text looks like a file path to an image
            if (this.isImageFilePath(textContent)) {
              this.loadImageFromPath(textContent);
              return;
            }
          }
        }
      }

      // No image found in clipboard
      this.snackbar.open('No image found in clipboard', '', {
        duration: 3000,
        verticalPosition: 'top'
      });

    } catch (error) {
      console.error('Error reading clipboard:', error);
      this.snackbar.open('Error reading clipboard. Please ensure clipboard access is granted.', '', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }

  private isImageFilePath(text: string): boolean {
    if (!text || typeof text !== 'string') {
      return false;
    }

    // Trim whitespace
    const trimmedText = text.trim();

    // Check if it looks like a file path (contains path separators)
    const hasPathSeparators = trimmedText.includes('\\') || trimmedText.includes('/');

    // Check for common image file extensions
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg'];
    const hasImageExtension = imageExtensions.some(ext =>
      trimmedText.toLowerCase().endsWith(ext)
    );

    return hasPathSeparators && hasImageExtension;
  }

  private async loadImageFromPath(filePath: string) {
    try {
      // Convert file path to File object
      const response = await fetch(`file://${filePath}`);
      if (!response.ok) {
        throw new Error(`Failed to load file: ${response.statusText}`);
      }

      const blob = await response.blob();
      const file = new File([blob], filePath.split(/[\\/]/).pop() || 'image', { type: blob.type });

      // Use the existing openFile method
      this.openFile(file, false);

      this.snackbar.open('Image loaded from file path', '', {
        duration: 3000,
        verticalPosition: 'top'
      });

    } catch (error) {
      console.error('Error loading image from path:', error);
      this.snackbar.open('Error loading image from file path. Please check the path is valid.', '', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }

  private handleDroppedFiles(files: FileList) {
    const imageFiles: File[] = [];

    // Filter for image files
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (this.isImageFile(file)) {
        imageFiles.push(file);
      }
    }

    if (imageFiles.length === 0) {
      this.snackbar.open('No image files found in dropped files', '', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }

    // Load each image file
    imageFiles.forEach((file, index) => {
      setTimeout(() => {
        this.openFile(file, false);
      }, index * 100); // Small delay between files to prevent overwhelming the UI
    });

    this.snackbar.open(`${imageFiles.length} image(s) loaded successfully`, '', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  private isImageFile(file: File): boolean {
    if (!file || !file.type) {
      return false;
    }

    // Check MIME type
    if (file.type.startsWith('image/')) {
      return true;
    }

    // Fallback: check file extension
    const fileName = file.name.toLowerCase();
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg'];
    return imageExtensions.some(ext => fileName.endsWith(ext));
  }

  private loadPastedImage(dataUrl: string) {
    try {
      const id = uuidv4();
      this.docId = 'D' + id;

      // Create a new TDOxImage for the pasted image
      const tdoImage = new TDOxImage();
      tdoImage.DocumentId = null;
      tdoImage.selected = true;
      tdoImage.URL = dataUrl;
      tdoImage.ImageID = this.docId;
      tdoImage.ImageName = this.currentPatientName + ' - Pasted Image';
      tdoImage.bImageLoaded = true;
      tdoImage.Categories = [];
      tdoImage.bImageSaved = false;
      tdoImage.selectedFile = null;
      tdoImage.blob = '';
      tdoImage.imageSource = 'Clipboard';
      tdoImage.folderId = this.fromOrganizer?.folderId;
      if (this.selectedCategories && this.selectedCategories.length > 0) {
        tdoImage.Categories = this.selectedCategories.map(p => p.ValidValueItemId);
      } else {
        tdoImage.Categories = [];
      }
      tdoImage.brightnessVal = 0;
      tdoImage.contrastVal = 0;
      tdoImage.gammaVal = 100;
      tdoImage.drawTextDefaults = this.drawTextDefaults;
      tdoImage.drawStampDefaults = this.drawStampDefaults;
      tdoImage.annotationsDefaults = this.annotationsDefaults;
      tdoImage.drawToolsDefaults = this.drawToolsDefaults;
      tdoImage.drawFunctionToolsDefaults = this.drawFunctionToolsDefaults;
      tdoImage.drawMagnificationDefaults = this.drawMagnificationDefaults;
      tdoImage.drawViewDetailDefaults = this.drawViewDetailDefaults;
      tdoImage.drawCanvasDefaults = this.drawCanvasDefaults;

      // Add to the list of open images
      this.listOpenImages.push(tdoImage);
      this.gammaVal = 100;
      this.contrastVal = 0;
      this.brightnessVal = 0;


      // Update the selected container to the new image
      setTimeout(() => {
        if (this.imageContainers.length > 0) {
          this.selectedContainer = this.imageContainers.last;
        }
      }, 100);

      this.snackbar.open('Image pasted successfully', '', {
        duration: 3000,
        verticalPosition: 'top'
      });

    } catch (error) {
      console.error('Error loading pasted image:', error);
      this.snackbar.open('Error loading pasted image', '', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }
}
